(() => {
	if (!window.disableNosto) {
		if (!customElements.get('main-collection')) {
			customElements.define(
				'main-collection',
				class MainCollection extends HTMLElement {
					hasInitializedInteractiveElements = false

					constructor() {
						super();

						this.nostoGQLEndpoint = 'https://search.nosto.com/v1/graphql'
						this.imagePlaceholder = 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 3 2\'%3E%3C/svg%3E'
						this.usAccountId = 'shopify-6186270804'
						this.usNostoKey = 'XXtivVl9ujlbky3kdlt0jKG2beNjfGIcCJU69Vq06yKyuuftKfJ4w7Y06q9xX0zq'

						this.auAccountId = 'shopify-7660404818'

						this.auNostoKey = 't1vw14RoWRg4zV8GRgz8YAMHTpYeMZ9Ck0QS9rHks59ZdNfuoKjnxSMymLAWHAn4'
						this.nostoGQLHeaders = {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': `Bearer ${window.theme.baseCurrency === 'USD'? this.usNostoKey: this.auNostoKey}`,
							}
						}
						this.selector = {
							bottomPagination: "#nosto-bottom-pagination"
						}

						this.commaDecimalCurrencies = ['EUR']

						this.sizeMapping = {
							'1X/2X': '1XL/2XL',
							'XL/2XL': '1XL/2XL',
							'1XL / 2XL': '1XL/2XL',
							'AU 1XL / 2XL': '1XL/2XL',
							'AU XL/2XL': '1XL/2XL',

							'2X/3X': '2XL/3XL',
							'2XL / 3XL': '2XL/3XL',
							'AU 2X/3X': '2XL/3XL',
							'AU 2XL / 3XL': '2XL/3XL',

							'3X/4X': '3XL/4XL',
							'3XL / 4XL': '3XL/4XL',
							'AU 3XL / 4XL': '3XL/4XL',
							'AU 3X/4X': '3XL/4XL',

							'4X/5X': '4XL/5XL',
							'4XL / 5XL': '4XL/5XL',
							'AU 4XL / 5XL': '4XL/5XL',
							'AU 4X/5X': '4XL/5XL',

							'5X/6X': '5XL/6XL',
							'5XL / 6XL': '5XL/6XL',
							'AU 4X/5X': '5XL/6XL',
							'AU 5X/6X': '5XL/6XL',

							'L / US 10': 'L',

							'US L/XL': 'L/XL',
							'AU L/XL': 'L/XL',
							'AU L / XL': 'L/XL',
							'LXL': 'L/XL',
							'L/Xl': 'L/XL',

							'US M/L': 'M/L',
							'M/L,': 'M/L',
							'AU M/L': 'M/L',
							'AU M / L': 'M/L',

							'ON SIZE': 'ONE SIZE',
							'OSFM': 'ONE SIZE',
										'ONE SIZE': 'ONE SIZE',
							'One Size': 'ONE SIZE',
							'Other': 'ONE SIZE',

							'RING SIZE 6 & 7': 'Ring Size 6',

							'Ring Size 6 & 7': 'Ring Size 7',
							'Ring Size 7 & 8': 'Ring Size 7',

							'RING SIZE 7 & 8': 'Ring Size 8',

							'RING SIZE 8 & 9': 'Ring Size 9',

							'US S/M': 'S/M',
							'AU S/M': 'S/M',
							'AU S / M': 'S/M',

							'US SHOE 10': 'SHOE US 10',
							'41': 'SHOE US 10',
							'10': 'SHOE US 10',

							'US SHOE 5': 'SHOE US 5',
							'36': 'SHOE US 5',
							'5': 'SHOE US 5',

							'US SHOE 6': 'SHOE US 6',
							'37': 'SHOE US 6',
							'6': 'SHOE US 6',

							'US SHOE 7': 'SHOE US 7',
							'38': 'SHOE US 7',
							'7': 'SHOE US 7',

							'US SHOE 8': 'SHOE US 8',
							'39': 'SHOE US 8',
							'8': 'SHOE US 8',

							'US SHOE 9': 'SHOE US 9',
							'40': 'SHOE US 9',
							'9': 'SHOE US 9',

							'L / US 10': 'US 10',

							'XL / US 12': 'US 12',

							'XXL - AU 18 / US 14': 'US 14',
							'XXL / US 14': 'US 14',

							'XS / US 4': 'US 4',
							'XS/US4': 'US 4',

							'S / US 6': 'US 6',

							'M / US 8': 'US 8',

							'S - AU 10': 'AU 10',

							'AU14': 'AU 14',
							'L / AU 14': 'AU 14',

							'XL / AU 16': 'AU 16',

							'XXL - AU 18': 'AU 18',
							'XXL - AU 18 / US 14': 'AU 18',

							'XXS - AU 6': 'AU 6',
							'XXS / AU 6': 'AU 6',

							'XS / AU 8': 'AU 8',

							'US XS/S': 'XS/S',
							'AU XS/S': 'XS/S',
							'AU XS / S': 'XS/S',
							'XS': 'XS/S',

							'XXL - AU 18 / US 14': 'XXL',

							'iPhone 12 / 12 PRO': 'IPHONE 12 PRO',
							'iPhone 12 / 12 Pro': 'IPHONE 12 PRO',
							'iPhone 12/Pro': 'IPHONE 12 PRO',
							'IPHONE 12 PRO': 'IPHONE 12 PRO',

							'iPhone 12 Pro Max': 'IPHONE 12 PRO MAX',
							'iPhone 12 ProMx': 'IPHONE 12 PRO MAX',
							'iPhone 12/ProMx': 'IPHONE 12 PRO MAX',
							'IPHONE 12 PRO MAX': 'IPHONE 12 PRO MAX',

							'iPhone 13/Pro': 'IPHONE 13 PRO',
							'IPHONE 13 PRO': 'IPHONE 13 PRO',

							'iPhone 13 ProMx': 'IPHONE 13 PRO MAX',
							'iPhone 13/Pro Max': 'IPHONE 13 PRO MAX',
							'iPhone 13/ProMx': 'IPHONE 13 PRO MAX',
							'iPhone 13ProMx': 'IPHONE 13 PRO MAX',
							'IPHONE 13 PRO MAX': 'IPHONE 13 PRO MAX',

							'IPHONE 14 PRO': 'IPHONE 14 PRO',
							'iPhone 14 Pro': 'IPHONE 14 PRO',

							'IPHONE 14 PRO MAX': 'IPHONE 14 PRO MAX',
							'iPhone 14 ProMx': 'IPHONE 14 PRO MAX',
							'iPhone 14 Pro Max': 'IPHONE 14 PRO MAX',

							'IPHONE 15 PRO': 'IPHONE 15 PRO',
							'iPhone 15 Pro': 'IPHONE 15 PRO',

							'IPHONE 15 PRO MAX': 'IPHONE 15 PRO MAX',
							'iPhone 15 ProMx': 'IPHONE 15 PRO MAX',
							'iPhone 15 Pro Max': 'IPHONE 15 PRO MAX'
						}

						this.sizeSortRanking = [
							'US 0',
							'US 2',
							'US 4',
							'US 6',,
							'US 8',
							'US 10',
							'US 12',
							'US 14',
							'US 16',
							'US 18',
							'US 20',
							'AU 0',
							'AU 2',
							'AU 4',
							'AU 6',,
							'AU 8',
							'AU 10',
							'AU 12',
							'AU 14',
							'AU 16',
							'AU 18',
							'AU 20',
							'AU 22',
							'AU 24',
							'XS/S',
							'S/M',
							'M/L',
							'L/XL',
							'2XL/3XL',
							'3XL/4XL',
							'4XL/5XL',
							'5XL/6XL',
							'A',
							'B',
							'C',
							'D',
							'SHOE US 5',
							'SHOE US 5.5',
							'SHOE US 6',
							'SHOE US 6.5',
							'SHOE US 7',
							'SHOE US 7.5',
							'SHOE US 8',
							'SHOE US 8.5',
							'SHOE US 9',
							'SHOE US 9.5',
							'SHOE US 10',
							'SHOE US 10.5',
							'IPHONE 11',
							'IPHONE 12',
							'IPHONE 13',
							'IPHONE 14',
							'IPHONE 15',
							'IPHONE 12 PRO',
							'IPHONE 13 PRO',
							'IPHONE 14 PRO',
							'IPHONE 15 PRO',
							'IPHONE 12 PRO MAX',
							'IPHONE 13 PRO MAX',
							'IPHONE 14 PRO MAX',
							'IPHONE 15 PRO MAX',
							'IPHONE 11 MINI',
							'IPHONE 12 MINI',
							'IPHONE 13 MINI',
							'IPHONE 14 MINI',
							'IPHONE 15 MINI',
							'RING SIZE 6',
							'RING SIZE 7',
							'RING SIZE 8',
							'RING SIZE 9',
							'RING SIZE 10',
						]

						this.facetSortRanking = [
							'size',
							'color',
							'style',
							'price',
							'print',
							'brand',
							'neckline'
						]

						this.initialProducts = null
						this.fetchingProducts = false
						this.totalProducts = ''
						this.refineByMobileSwpr = null

						const pageUrl = new URL(window.location)
						const pageLimit = pageUrl.searchParams.get("limit")
						this.pageSize = parseInt(pageLimit) || 48;

						this.init()

						this.wishProducts = []
						fetchCollectionWishlists()
						document.addEventListener('collection:wishlist', (event) => {
							if (document.querySelector('[data-nosto-collection]')) {
								const productTiles = document.querySelectorAll('[data-nosto-collection] [data-product-tile]')

								this.wishProducts = event.detail

								Array.from(productTiles).forEach(tile => {
									this.initializeWishlists(tile)
								})
							}
						})
					};

					init() {
						if (this.isReady()) {
							this.initializeSortOrder()
							this.initializeSortWidths()

							this.bindFacetButtons()
							this.bindFacetSelectionBoxes()
							this.bindFacetSelectionSliders()
							this.bindPaginationNextButtons()
							this.bindPaginationPrevButtons()
							this.bindPaginationJumpButtons()
							this.bindRemoveFilterButtons()
							this.bindSortSelect()
							this.bindRemoveAllFilters()

							this.createSearchPageHeader()

							if (!this.fetchingProducts) {
								this.updateVisibleProducts()
							}

							this.initFilters()
							this.closeMenuDesktop()
							this.quickAddEvents()
						} else {
							this.updateVisibleProducts()
						}
					};

					initializeWishlists(tile) {
						let observer = new IntersectionObserver((entries, observer) => {
							entries.forEach(entry => {
								if (entry.isIntersecting || entry.intersectionRatio > 0) {
									this.renderWishlists(tile)
									observer.unobserve(entry.target)
								}
							})
						})
						observer.observe(tile)
					};

					renderWishlists(tile) {
						const p = tile
						const pId = p.hasAttribute('data-id') ? parseInt(p.getAttribute('data-id')) : null
						if (pId) {
							if (this.wishProducts.some(wp => wp.empi === pId)) {
								p.classList.add('wish-exists')
							} else {
								p.classList.remove('wish-exists')
							}
						}
					};

					isReady() {
						return document.querySelector('[data-nosto-collection]')
					};

					closeMenuDesktop() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-collections-filter-view]')) {
								document.querySelector('[data-collection-facet-button].active').classList.remove('active')
								document.querySelector('[data-collection-filter-menu].active').classList.remove('active')
							}
						})
					}

					bindSortSelect() {
						document.addEventListener('change', (e) => {
							if (e.target.matches('#collection-sort-select')) {
								this.updateStateQueryParams()
								this.updateVisibleProducts()
							}
						})
					}

					bindFacetButtons() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-collection-facet-button]')) {
								const clickedFacetName = e.target.dataset.facetName
								const button = document.querySelector(`[data-collection-facet-button][data-facet-name="${clickedFacetName}"]`)
								const buttonSiblings = Array.from(button.parentNode.children).filter(child => child !== button)
								const menu = document.querySelector(`[data-collection-filter-menu][data-facet-name="${clickedFacetName}"]`)
								const menuSiblings = Array.from(menu.parentNode.children).filter(child => child !== menu)
								buttonSiblings.forEach(button => {
									if (button.classList.contains('active')) button.classList.remove('active')
								})
								button.classList.toggle('active')
								menuSiblings.forEach(menu => {
									if (menu.classList.contains('active')) menu.classList.remove('active')
								})
								menu.classList.toggle('active')
							}
						})
					}

					bindFacetSelectionBoxes() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-collection-facet-checkbox]')) {
								const target = e.target
								target.classList.toggle('checked')
								this.buildFilterClearButtons()
								this.updateStateQueryParams()
								this.updateVisibleProducts()
							}
						})
					}

					bindFacetSelectionSliders() {
						document.addEventListener('input', (e) => {
							if (e.target.matches('[data-facet-slider-control] [data-from-slider]')) {
								const target = e.target
								const parentContainer = target.closest('[data-facet-slider-container]')
								const fromDisplay = parentContainer.querySelector('[data-from-display]')
								fromDisplay.innerHTML = target.value
							}
						})

						document.addEventListener('input', (e) => {
							if (e.target.matches('[data-facet-slider-control] [data-to-slider]')) {
								const target = e.target
								const parentContainer = target.closest('[data-facet-slider-container]')
								const toDisplay = parentContainer.querySelector('[data-to-display]')
								toDisplay.innerHTML = target.value
							}
						})

						document.addEventListener('mouseup', (e) => {
							if (e.target.matches('[data-facet-slider-control] [data-from-slider]') || e.target.matches('[data-facet-slider-control] [data-to-slider]')) {
								this.buildFilterClearButtons()
								this.updateStateQueryParams()
								this.updateVisibleProducts()
							}
						})
					}

					bindPaginationNextButtons() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-next-page-button]')) {
								const urlParams = new URLSearchParams(window.location.search)
								let currentPage = urlParams.get('page')
								if (currentPage) {
									urlParams.set('page', parseInt(currentPage) + 1)
								} else {
									urlParams.set('page', 2)
								}

								let newUrl = window.location.href.split('?')[0]
								const urlParamString = urlParams.toString()
								if (urlParamString.length > 0) {
									newUrl += '?' + urlParamString
								}

								window.history.pushState({}, null, newUrl)
								document.body.scrollTop = document.documentElement.scrollTop = 0
								this.updateVisibleProducts()
							}
						})
					}

					bindPaginationPrevButtons() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-prev-page-button]')) {
								const urlParams = new URLSearchParams(window.location.search)
								let currentPage = urlParams.get('page')
								if (currentPage) {
									if (currentPage == 2) {
										urlParams.delete('page')
									} else {
										urlParams.set('page', parseInt(currentPage) - 1)
									}

									let newUrl = window.location.href.split('?')[0]
									const urlParamString = urlParams.toString()
									if (urlParamString.length > 0) {
										newUrl += '?' + urlParamString
									}

									window.history.pushState({}, null, newUrl)
									document.body.scrollTop = document.documentElement.scrollTop = 0
									this.updateVisibleProducts()
								}
							}
						})
					}

					bindPaginationJumpButtons() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-jump-page-button]')) {
								const target = e.target
								if (target.hasAttribute('data-page-num')) {
									const urlParams = new URLSearchParams(window.location.search)
									if (target.getAttribute('data-page-num') > 1) {
										urlParams.set('page', target.getAttribute('data-page-num'))
									} else {
										urlParams.delete('page')
									}

									let newUrl = window.location.href.split('?')[0]
									const urlParamString = urlParams.toString()
									if (urlParamString.length > 0) {
										newUrl += '?' + urlParamString
									}

									window.history.pushState({}, null, newUrl)
									document.body.scrollTop = document.documentElement.scrollTop = 0
									this.updateVisibleProducts()
								}
							}
						})
					}

					bindRemoveFilterButtons() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-header-refine-by] button')) {
								const target = e.target
								const filterToRemove = target.getAttribute('data-facet-value')
								if (target.hasAttribute('data-slider-clear')) {
									const facetName = target.getAttribute('data-facet-name')
									this.clearRangeFilter(facetName)
									this.buildFilterClearButtons()
									this.updateStateQueryParams()
									this.updateVisibleProducts()
								} else {
									const input = document.querySelector(`[data-collection-facet-checkbox][data-facet-value="${filterToRemove}"].checked`)
									if (input) input.click()
								}
							}
						})
					}

					bindRemoveAllFilters() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-collections-filter-clear]')) {
								this.removeAllFilters()
							}
						})
					}

					resetRangeFilters() {
						document.querySelectorAll('[data-from-slider]').forEach(slider => {
							slider.value = slider.min
							const parentContainer = slider.closest('[data-facet-slider-container]')
							const fromDisplay = parentContainer.querySelector('[data-from-display]')
							fromDisplay.innerHTML = slider.value
						})

						document.querySelectorAll('[data-to-slider]').forEach(slider => {
							slider.value = slider.max
							const parentContainer = slider.closest('[data-facet-slider-container]')
							const toDisplay = parentContainer.querySelector('[data-to-display]')
							toDisplay.innerHTML = slider.value
						})
					}

					clearRangeFilter(facetName) {
						const filterContainers = document.querySelectorAll(`[data-facet-slider-control][data-facet-name=${facetName}]`)
						filterContainers.forEach(filterContainer => {
							const fromSlider = filterContainer.querySelector('[data-from-slider]')
							if (fromSlider) {
								fromSlider.value = fromSlider.min
								const parentContainer = fromSlider.closest('[data-facet-slider-container]')
								const fromDisplay = parentContainer.querySelector('[data-from-display]')
								fromDisplay.innerHTML = fromSlider.value
							}

							const toSlider = filterContainer.querySelector('[data-to-slider]')
							if (toSlider) {
								toSlider.value = toSlider.max
								const parentContainer = toSlider.closest('[data-facet-slider-container]')
								const toDisplay = parentContainer.querySelector('[data-to-display]')
								toDisplay.innerHTML = toSlider.value
							}
						})
					}

					removeAllFilters() {
						document.querySelectorAll('[data-collection-facet-checkbox][data-facet-value].checked').forEach(el => {
							el.classList.remove('checked')
						})
						this.resetRangeFilters()
						this.buildFilterClearButtons()
						this.updateStateQueryParams()
						this.updateVisibleProducts()
					}

					getCurrentPage() {
						const urlParams = new URLSearchParams(window.location.search)

						let currentPage = urlParams.get('page')
						if (!currentPage) {
							currentPage = 1
						}
						if (!isNaN(currentPage)) {
							currentPage = parseInt(currentPage)
						} else {
							currentPage = 1
						}
						if (currentPage < 1) {
							currentPage = 1
						}

						if (currentPage > window.maxPages) {
							currentPage = window.maxPages
						}

						return currentPage
					}

					getActiveFilters() {
						// Get Active Filters For Nosto Query
						const activeFiltersDict = {
							availability: ['InStock']
						}
						const rangeFilters = {}

						const url = new URL(window.location.href)
						const searchParams = new URLSearchParams(url.search)
						for (const param of searchParams) {
							const key = param[0]
							if (key.startsWith('filter.')) {
								const newKey = key.split('filter.')[1]
								const newValues = param[1].split(',')
								activeFiltersDict[newKey] = newValues
							}

							if (key.startsWith('filterRange.')) {
								const splitKey = key.split('.')
								const rangeValue = param[1]
								if (splitKey.length === 3) {
									const rangeKey = splitKey[1]
									const rangeTitle = splitKey[2]
									if (!(rangeTitle in rangeFilters)) {
										rangeFilters[rangeTitle] = {}
									}

									rangeFilters[rangeTitle][rangeKey] = rangeValue
								}
							}
						}

						const activeFilters = []
						Object.keys(activeFiltersDict).forEach(key => {
							const currentValues = activeFiltersDict[key]
							let newValues = currentValues
							if (key === 'skus.customFields.size') {
								newValues = []
								currentValues.forEach(value => {
									newValues.push(value)
									const sizeMappingKeys = Object.keys(this.sizeMapping)
									const filteredDictValues = sizeMappingKeys.filter(key => this.sizeMapping[key] === value)
									if (filteredDictValues.length > 0) {
										newValues = newValues.concat(filteredDictValues)
									}
								})
							}
							activeFilters.push({field: key, value: newValues})
						})

						Object.keys(rangeFilters).forEach(key => {
							activeFilters.push({field: key, range: rangeFilters[key]})
						})

						const hidePfsFilter = {
							"not": [{
								"any": [
									{
										"field": "tags1",
										"value": 'pfs:hidden'
									},
									{
										"field": "tags2",
										"value": 'pfs:hidden'
									},
									{
										"field": "tags3",
										"value": 'pfs:hidden'
									}
								]
							}]
						}

						activeFilters.push(hidePfsFilter)
						return activeFilters
					}

					initializeSortOrder() {
						const url = new URL(window.location.href)
						const searchParams = new URLSearchParams(url.search)
						const sortParam = searchParams.get('sortOrder')
						if (sortParam) {
							document.querySelector('#collection-sort-select').value = sortParam
						}
					}

					sortWidths() {
						const text = document.querySelector('[data-collection-sort-selected]')
						const sortSelect = document.querySelector('#collection-sort-select')
						if (text && sortSelect) {
							const sortSelectLabel = sortSelect.options[sortSelect.selectedIndex].text
							text.textContent = sortSelectLabel
						}
					}

					initializeSortWidths() {
						this.sortWidths()

						document.addEventListener('change', (e) => {
							if (e.target.matches('#collection-sort-select')) {
								this.sortWidths()
							}
						})
					}

					getSortOrder() {
						const isNewCollection = window.location.pathname.includes('/collections/')
							&& window.location.pathname.includes('new')
							&& !window.location.pathname.includes('new-to-sale')
							&& !window.initialSortSet

						window.initialSortSet = true

						const url = new URL(window.location.href)
						const searchParams = new URLSearchParams(url.search)

						let sortOrderSelect = document.querySelector('#collection-sort-select')
						let sortOrderValue = sortOrderSelect ? sortOrderSelect.value : 'featured'

						if (!sortOrderSelect) {
							sortOrderValue = searchParams.has('sortOrder') ? searchParams.get('sortOrder') : 'featured'
						} else if (searchParams.get('sortOrder')) {
							sortOrderValue = searchParams.get('sortOrder')
						} else if (isNewCollection) {
							try {
								sortOrderSelect.value = 'newest'
								searchParams.set('sortOrder', 'newest')

								let newPageUrl = window.location.href.split('?')[0]
								const searchParamString = searchParams.toString()
								if (searchParamString.length > 0) {
									newPageUrl += '?' + searchParams.toString()
								}
								window.history.pushState({}, null, newPageUrl)

								sortOrderValue = 'newest'
							}
							catch(e) {
								console.error(e)
							}
						}
						let sortOrder = []
						switch(sortOrderValue) {
							case 'newest':
								sortOrder = [{field: 'datePublished', order: 'desc'}]
								break
							case 'low-high':
								sortOrder = [{field: 'price', order: 'asc'}]
								break
							case 'high-low':
								sortOrder = [{field: 'price', order: 'desc'}]
								break
						}
						return sortOrder
					}

					getPLPFacetRequestBody() {
						let nostoQuery = `
							query($categoryPath: String) {
								search(
									accountId: "${window.theme.baseCurrency === 'USD'? this.usAccountId: this.auAccountId}"
									products: {
										categoryPath: $categoryPath,
										size: ${this.pageSize},
									}
								) {
									products {
										facets {
											... on SearchTermsFacet {
												id
												field
												type
												name
												data {
													value
													count
													selected
												}
											}
											... on SearchStatsFacet {
												id
												field
												type
												name
												min
												max
											}
										}
										total
										size
									}
								}
							}
						`

						let requestBody = {
							'query': nostoQuery,
							'variables': {
								'categoryPath': window.nostoCategoryPath,
							}
						}
						return requestBody
					}

					getSearchPageFacetRequestBody() {
						let nostoQuery = `
							query($queryString: String) {
								search(
									accountId: "${window.theme.baseCurrency === 'USD'? this.usAccountId: this.auAccountId}"
									query: $queryString
									products: {
									size: ${this.pageSize},
									}
								) {
									products {
										facets {
											... on SearchTermsFacet {
												id
												field
												type
												name
												data {
													value
													count
													selected
												}
											}
											... on SearchStatsFacet {
												id
												field
												type
												name
												min
												max
											}
										}
										total
										size
									}
								}
							}
						`

						const urlParams = new URLSearchParams(window.location.search)
						const searchQuery = urlParams.get('q')
						let requestBody = {
							'query': nostoQuery,
							'variables': {
								'queryString': searchQuery? searchQuery : ''
							}
						}
						return requestBody
					}

					getPLPNostoRequestBody(currentPage, activeFilters, sortOrder) {
						// Query Visible Products From Nosto
						const customRules = []

						try {
							if (window.nostoCategoryPath) {
								const formattedCategoryPath = window.nostoCategoryPath.toLowerCase().trim()
								if (formattedCategoryPath.includes('new') && formattedCategoryPath !== 'new to sale') {
									customRules.push(
										{
											id: "date_published_boost",
											name: "Date Published Boost",
											enabled: true,
											match: {
												everything: true
											},
											set: {
												products: {
													boost: [
														{
															field: "datePublished",
															weight: 100
														}
													],
													pin: []
												}
											}
										}
									)
								}
							}
						}
						catch(e) {
							console.error(e)
						}

						let nostoQuery = `
							query($categoryPath: String, $filters: [InputSearchTopLevelFilter!], $sortOrder: [InputSearchSort!], $customRules: [InputSearchRule!]) {
								search(
									accountId: "${window.theme.baseCurrency === 'USD'? this.usAccountId: this.auAccountId}"
									products: {
										categoryPath: $categoryPath,
										size: ${this.pageSize},
										from: ${(currentPage - 1) * this.pageSize},
										filter: $filters,
										sort: $sortOrder
									},
									customRules: $customRules
								) {
									products {
										hits {
											datePublished
											url
											name
											productId
											imageUrl
											thumbUrl
											brand
											availability
											price
											listPrice
											categoryIds
											inventoryLevel
											tags1
											tags2
											tags3
											priceCurrencyCode
											alternateImageUrls
											skus {
												id
												name
												price
												url
												imageUrl
												availability
												customFields {
													key
													value
												}
											}
											customFields {
												key
												value
											}
										}
										total
										size
									}
								}
							}
						`

						let requestBody = {
							'query': nostoQuery,
							'variables': {
								'categoryPath': window.nostoCategoryPath,
								'filters': activeFilters,
								'sortOrder': sortOrder,
								'customRules': customRules
							}
						}
						return requestBody
					}

					getSearchPageNostoRequestBody(currentPage, activeFilters, sortOrder) {
						const nostoQuery = `
							query($queryString: String, $filters: [InputSearchTopLevelFilter!], $sortOrder: [InputSearchSort!]) {
								search(
									accountId: "${window.theme.baseCurrency === 'USD'? this.usAccountId: this.auAccountId}"
									query: $queryString
									products: {
										size: ${this.pageSize},
										from: ${(currentPage - 1) * this.pageSize},
										filter: $filters,
										sort: $sortOrder
									}
								) {
									redirect
									products {
										hits {
											datePublished
											url
											productId
											name
											imageUrl
											thumbUrl
											brand
											availability
											price
											listPrice
											categoryIds
											inventoryLevel
											tags1
											tags2
											tags3
											priceCurrencyCode
											alternateImageUrls
											skus {
												id
												name
												price
												url
												imageUrl
												availability
												customFields {
													key
													value
												}
											}
											customFields {
												key
												value
											}
										}
										total
										size
									}
								}
							}
						`

						const urlParams = new URLSearchParams(window.location.search)
						const searchQuery = urlParams.get('q')
						const requestBody = {
							'query': nostoQuery,
							'variables': {
								'queryString': searchQuery? searchQuery : '',
								'filters': activeFilters,
								'sortOrder': sortOrder
							}
						}
						return requestBody
					}

					updateStateQueryParams() {
						// Remove non-active filter query params
						const url = new URL(window.location.href)
						const searchParams = new URLSearchParams(url.search)
						let paramsToRemove = ['page']
						for (const param of searchParams) {
							const key = param[0]
							if (key.startsWith('filter.') || key.startsWith('filterRange.')) {
								paramsToRemove.push(key)
							}
						}
						paramsToRemove.forEach(param => {
							searchParams.delete(param)
						})

						// Add each filter value to url based on active filter checkboxes
						const activeFiltersDict = {}
						const activeFilterCheckboxes = document.querySelectorAll('[data-collection-facet-checkbox].checked')
						activeFilterCheckboxes.forEach(checkbox => {
							const field = checkbox.dataset.facetName
							const value = checkbox.dataset.facetValue
							if (field in activeFiltersDict) {
								activeFiltersDict[field].push(value)
							} else {
								activeFiltersDict[field] = [value]
							}
						})

						const activeFilters = []
						Object.keys(activeFiltersDict).forEach(key => {
							const uniq = [...new Set(activeFiltersDict[key])]
							activeFilters.push({field: key, value: uniq})
						})
						activeFilters.forEach(filter => {
							const newKey = 'filter.' + filter.field
							const fieldValuesJoined = filter.value.join(',')

							searchParams.append(newKey, fieldValuesJoined)
						})

						// Check slider filters
						const facetSliders = document.querySelectorAll('[data-facet-slider-control]')
						facetSliders.forEach(slider => {
							const fromSlider = slider.querySelector('[data-from-slider]')
							const toSlider = slider.querySelector('[data-to-slider]')
							if (fromSlider && toSlider) {
								const fromValue = fromSlider.value
								const fromMin = fromSlider.min
								if (fromValue != fromMin) {
									const newKey = 'filterRange.gte.' + slider.dataset.facetName
									const fieldValue = fromValue
									searchParams.append(newKey, fieldValue)
								}

								const toValue = toSlider.value
								const toMax = toSlider.max
								if (toValue != toMax) {
									const newKey = 'filterRange.lte.' + slider.dataset.facetName
									const fieldValue = toValue
									searchParams.append(newKey, fieldValue)
								}
							}
						})

						const selectedSortOption = document.querySelector('#collection-sort-select').value
						if (selectedSortOption !== 'featured') {
							searchParams.set('sortOrder', selectedSortOption)
						} else {
							searchParams.delete('sortOrder')
						}

						let newPageUrl = window.location.href.split('?')[0]
						const searchParamString = searchParams.toString()
						if (searchParamString.length > 0) {
							newPageUrl += '?' + searchParams.toString()
						}
						window.history.pushState({}, null, newPageUrl)
					}

					updateProductPromotions() {
						window.dispatchEvent(new CustomEvent('collection.productPromotion', {
							detail: this.querySelector('product-promotion')
						}))
					}

					updateVisibleProducts() {
						this.fetchingProducts = true

						if (this.isReady() && this.initialProducts) {
							// console.log('[COLLECTION]', 'Loading initial products')
							this.visibleProductsCallback(this.initialProducts, this.totalProducts)
							this.initialProducts = null
							return
						}

						const currentPage = this.getCurrentPage()
						const from = (currentPage - 1) * this.pageSize
						const activeFilters = this.getActiveFilters()
						const sortOrder = this.getSortOrder()
						let requestBody = null

						if (!window.isNostoSearchPage) {
							requestBody = this.getPLPNostoRequestBody(currentPage, activeFilters, sortOrder)
						} else {
							requestBody = this.getSearchPageNostoRequestBody(currentPage, activeFilters, sortOrder)
						}

						fetch(this.nostoGQLEndpoint, {
							method: 'POST',
							headers: this.nostoGQLHeaders,
							body: JSON.stringify(requestBody)
						})
						.then((response) => response.json())
						.then((res) => {
							// console.log('res', res)
							const products = res.data.search.products.hits
							const totalProducts = res.data.search.products.total
							this.totalProducts = totalProducts

							if (window.isNostoSearchPage && res.data.search.redirect) {
								window.location.href = res.data.search.redirect
							}

							try {
								this.sendCategoryNostoAnalytics(res, activeFilters, sortOrder, from)
							} catch(e) {
								console.error(e)
							}

							if (this.isReady()) {
								// console.log('[COLLECTION]', 'Loading products')
								this.visibleProductsCallback(products, totalProducts)
							} else {
								// console.log('[COLLECTION]', 'Preloading products')
								this.initialProducts = products
							}

							this.fetchingProducts = false

							if (totalProducts == 0) {
								document.documentElement.classList.add('no-results')
							} else {
								document.documentElement.classList.remove('no-results')
							}

							const search = document.querySelector('main-collection.collection--search')
							if (search) {
								if (!products.length) {
									document.documentElement.classList.add('no-search-results')
								} else {
									document.documentElement.classList.remove('no-search-results')
									search.classList.remove('hide-filters')
								}
							}
						})
						.catch((e) => {
							console.error(e)
						})
					}

					sendCategoryNostoAnalytics(response, filters, sort, from) {
						const urlParams = new URLSearchParams(window.location.search)
						const searchQuery = urlParams.get('q')
						const type = window.isNostoSearchPage? 'serp' : 'category'
						const queryTerm = window.isNostoSearchPage? searchQuery : window.nostoCategoryPath
						const query = {
							products: {
								sort: sort,
								filters: filters
							}
						}
						if (window.isNostoSearchPage) {
							query.query = queryTerm
						}

						const searchResult = response.data.search
						let filteredHits = []
						if (searchResult) {
							if (searchResult.hasOwnProperty('redirect')) {
								delete searchResult['redirect']
							}
							if (searchResult.products) {
								if (!isNaN(from)) {
									searchResult.products.from = from
								}
								if (!window.isNostoSearchPage && window.shopifyCollection) {
									if (window.shopifyCollection.id) {
										searchResult.products.categoryId = window.shopifyCollection.id.toString()
									}
								}
								if (searchResult.products.hits) {
									searchResult.products.hits.forEach(product => filteredHits.push({productId: product.productId}))
									searchResult.products.hits = filteredHits
								}
							}
						}

						const options = {isKeyword: false}
						if (!window.nostojs) {
							(function() {
								let name = 'nostojs'
								window[name] = window[name] || function(cb) { (window[name].q = window[name].q || []).push(cb) }
							})()
						}

						window.nostojs(api => {
							api.recordSearch(
								type,
								query,
								searchResult,
								options
							)
						})
					}

					bindNostoClickEvent() {
						document.addEventListener('click', (e) => {
							const target = e.target
							if (target.matches('.product-tile a')) {
								const productId = target.closest('.product-tile').dataset.id || ''
								e.preventDefault()
								window.nostojs(api => {
									const type = window.isNostoSearchPage? 'serp' : 'category'
									const url = target.href
									const hit = {
										productId: productId,
										url: url
									}
									api.recordSearchClick(type, hit)
								})
								if (!target.matches('[data-swatch]')) {
									window.location.href = target.href
								}
							}
						})
					}

					visibleProductsCallback(products, totalProducts) {
						this.buildProductTiles(products)
						this.buildPagination(totalProducts)
						this.buildViewButtons(totalProducts)
						this.initializeSwipers()

						if(!this.hasInitializedInteractiveElements) {
							this.bindNostoClickEvent()
							this.swatchEvents()
							this.initializeQuickAddButtons()
							this.hasInitializedInteractiveElements = true
						}

						this.createQuickAddRenderListener()
						this.buildProductTileSwatches()
						this.updateProductPromotions()
					}

					buildMobileRefineBy() {
						const refineByMobile = document.querySelector('[data-header-refine-by="mobile"')
						const slides = refineByMobile.querySelectorAll('[data-facet-name]')

						if (slides.length) {
							const carousel = refineByMobile.parentElement

							if (carousel.classList.contains('swiper-initialized')) {
								carousel.classList.remove('swiper-initialized')
							}

							refineByMobile.classList.add('swiper-wrapper')
							slides.forEach((slide) => {
								slide.classList.add('swiper-slide')
							})

							if (this.refineByMobileSwpr) {
								this.refineByMobileSwpr.destroy()
								this.refineByMobileSwpr = null
							}

							this.refineByMobileSwpr = new Swiper(carousel, {
								freeMode: true,
								loop: false,
								roundLengths: false,
								slidesPerView: 'auto',
								slideToClickedSlide: true,
								spaceBetween: 10,
								watchSlidesVisibility: true
							})
						}
					}

					buildProductTileSwatches() {
						let swatchCollections = []
						document.querySelectorAll('[data-swatch-products]').forEach((item) => {
							if (!swatchCollections.includes(item.dataset.swatchProducts)) {
								swatchCollections.push(item.dataset.swatchProducts)
								this.ajaxCollectionData(item.dataset.swatchProducts)
							}
						})
					}

					buildFilterClearButtons() {
						const refineBy = document.querySelectorAll('[data-header-refine-by')

						refineBy.forEach((el) => {
							el.innerHTML = ''
						})

						const activeFilterCheckboxes = document.querySelectorAll('[data-collection-facet-checkbox].checked')
						activeFilterCheckboxes.forEach((filter) => {
							refineBy.forEach((el) => {
								const filterMarkup = document.createElement('button')
								filterMarkup.setAttribute('data-facet-name', filter.getAttribute('data-facet-name'))
								filterMarkup.setAttribute('data-facet-value', filter.getAttribute('data-facet-value'))
								filterMarkup.innerHTML = `
									<small class="visually-hidden">Remove</small>
									${filter.getAttribute('data-facet-value')} (${filter.getAttribute('data-count')})
									<span style="pointer-events: none;">
										<svg version="1.1" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" xml:space="preserve">
											<line fill="none" stroke="#231F20" x1="0.65" y1="0.5" x2="9.35" y2="9.5"/>
											<line fill="none" stroke="#231F20" x1="0.5" y1="9.35" x2="9.5" y2="0.65"/>
										</svg>
									</span>
								`

								if (!el.querySelector(`[data-facet-value="${filter.getAttribute('data-facet-value')}"]`)) {
									el.append(filterMarkup)
								}
							})
						})

						const filterSliderContainers = document.querySelectorAll('[data-facet-slider-control]')
						filterSliderContainers.forEach((el) => {
							const fromSlider = el.querySelector('[data-from-slider]')
							const toSlider = el.querySelector('[data-to-slider]')
							const facetName = el.dataset.facetName
							if (fromSlider && toSlider) {
								if (fromSlider.value != fromSlider.min || toSlider.value != toSlider.max) {
									refineBy.forEach((el) => {
										const filterMarkup = document.createElement('button')
										filterMarkup.setAttribute('data-facet-name', facetName)
										filterMarkup.setAttribute('data-facet-value', `${fromSlider.value}-${toSlider.value}`)
										filterMarkup.setAttribute('data-slider-clear', '')
										filterMarkup.innerHTML = `
											<small class="visually-hidden">Remove</small>
											$${fromSlider.value} - $${toSlider.value}
											<span style="pointer-events: none;">
												<svg version="1.1" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" xml:space="preserve">
													<line fill="none" stroke="#231F20" x1="0.65" y1="0.5" x2="9.35" y2="9.5"/>
													<line fill="none" stroke="#231F20" x1="0.5" y1="9.35" x2="9.5" y2="0.65"/>
												</svg>
											</span>
										`

										if (!el.querySelector(`[data-facet-value="${fromSlider.value}-${toSlider.value}"]`)) {
											el.append(filterMarkup)
										}
									})
								}
							}
						})
						this.buildMobileRefineBy()
					}

					buildWishlist(product) {
						let variantId
						let productHandle
						let productId
						let productUrl

						if (product.hasOwnProperty('skus') && product.skus) {
							variantId = product.skus.length ? product.skus[0].id : product.productId
							productHandle = product.url.split('/products/')[1].split('/')[0].split('?')[0]
							productId = product.productId
							productUrl = product.url
						} else if (product.hasOwnProperty('variants')) {
							variantId = product.variants.length ? product.variants[0].id : product.id
							productHandle = product.handle
							productId = product.id
							productUrl = `${window.location.origin}/products/${productHandle}`
						}

						let wishlistMarkup = `
							<button
								class="swym-button swym-add-to-wishlist-view-product product_${productId}"
								tabindex="0"
								data-with-epi="true"
								data-swym-wishlist-button
								data-swaction="addToWishlist"
								data-product-id="${productId}"
								data-variant-id="${variantId}"
								data-product-url="${productUrl}"
							>
								<span class="icon icon--wishlist"></span>
							</button>
							<button class="wish-button" data-product-handle="${productHandle}" aria-label="open wishlist modal"></button>
						`.trim()

						return wishlistMarkup
					}

					buildFilters(facets) {
						facets = facets.filter(facet => {
							if (facet.name) {
								if (window.disabledNostoFilters) {
									const disabledNostoFilters = window.disabledNostoFilters
									if (disabledNostoFilters.length > 0) {
										if (disabledNostoFilters.includes(facet.name.toLowerCase())) {
											return false
										}
									}
								}
							}
							return true
						})

						const filterContainer = document.querySelector('[data-collection-filters-desktop]')
						const filterMenuContainer = document.querySelector('[data-collection-filter-menu-container]')
						if (filterContainer && filterMenuContainer) {
							if (filterContainer.childElementCount === 0) {
								facets.forEach((facet) => {
									if (facet.field) {
										const filterMarkup = `
											<button class="collection__facet-button" data-collection-facet-button data-facet-name="${facet.field}" id="filter-${this.handleize(facet.field)}">${facet.name}</button>
										`
										const newElement = this.createElementFromHTML(filterMarkup)
										filterContainer.appendChild(newElement)
										let filterOptions = ''
										if (facet.type === 'terms') {
											let uniqueOptionValues = JSON.parse(JSON.stringify(facet.data))
											if (facet.field === 'skus.customFields.size') {
												uniqueOptionValues = []
												facet.data.forEach(option => {
													let mappedOption = JSON.parse(JSON.stringify(option))

													if (option.value in this.sizeMapping) {
														mappedOption.value = this.sizeMapping[option.value]
													}
													if (!uniqueOptionValues.some(e => e.value == mappedOption.value)) {
														uniqueOptionValues.push(mappedOption)
													}
												})
												uniqueOptionValues.sort((a, b) => {
													const aIndex = this.sizeSortRanking.includes(a.value)? this.sizeSortRanking.indexOf(a.value): '500'
													const bIndex = this.sizeSortRanking.includes(b.value)? this.sizeSortRanking.indexOf(b.value): '500'
													return aIndex - bIndex
												})
											}

											uniqueOptionValues.forEach(option => {
												let swatchImage = ''
												if (this.handleize(facet.name) == 'color' || this.handleize(facet.name) == 'colour') {
													const swatchURL = window.theme.fileURL.replace(/\?/, `color-${this.handleize(option.value)}_48x48.png?v=`)
													swatchImage = `
														<span
															class="collection__facet-selection-swatch"
															style="background-color: ${this.handleize(option.value)}; background-image: url('${swatchURL}');"
															title="${option.value}"
															data-collection-facet-swatch
														></span>
													`
												}
												const optionMarkup = `
													<li class="collection__facet-selection-item" role="presentation">
														<button
															class="collection__facet-selection-checkbox"
															data-facet-name="${facet.field}"
															data-facet-value="${option.value}"
															data-collection-facet-checkbox
															data-count="${option.count}"
															aria-checked="false"
															role="checkbox"
														>${swatchImage}${option.value} (${option.count})</button>
													</li>
												`
												filterOptions += optionMarkup
											})

											const filters = ['color', 'colour', 'size']
											const type = filters.includes(this.handleize(facet.name)) ? 'flex' : 'none'
											const hidden = filters.includes(this.handleize(facet.name)) ? 'false' : 'true'
											filterOptions = `<ul class="collection__filter-list" id="filter-menu-${this.handleize(facet.name)}" style="display: ${type};" aria-hidden="${hidden}">${filterOptions}</ul>`
										} else if (facet.type === 'stats') {
											const facetMin = Math.floor(facet.min)
											const facetMax = Math.ceil(facet.max)
											filterOptions += `
											<li class="collection__facet-range-container" data-facet-slider-container>
												<div class="sliders_control" data-facet-slider-control data-facet-name="${facet.field}">
													<input class="from-slider" data-from-slider type="range" value="${facetMin}" min="${facetMin}" max="${facetMax}"/>
													<input class="to-slider" data-to-slider type="range" value="${facetMax}" min="${facetMin}" max="${facetMax}"/>
												</div>
												<div class="sliders-display" data-facet-name="${facet.field}">
													<span data-from-display>${facetMin}</span>
													<span data-to-display>${facetMax}</span>
												</div>
											</li>
											`

											filterOptions = `<ul class="collection__filter-list filter-slider" id="filter-menu-${this.handleize(facet.name)}" style="display: none;">${filterOptions}</ul>`
										}

										const filters = ['color', 'colour', 'size']
										const toggleClass = filters.includes(this.handleize(facet.name)) ? ' active-toggle' : ''
										const expanded = filters.includes(this.handleize(facet.name)) ? 'true' : 'false'

										const filterMenuMarkup = `
											<div
												class="collection__filter-menu"
												data-facet-name="${facet.field}"
												data-collection-filter-menu
												role="group"
												aria-labelledby="filter-${this.handleize(facet.field)}"
											>
												<div class="collection__filter-menu-inner${toggleClass}">
													<button
														class="collection__filter-menu-title"
														data-toggle="> ul"
														data-toggle-style="flex"
														aria-controls="filter-menu-${this.handleize(facet.name)}"
														aria-label="${facet.name}"
														aria-expanded="${expanded}"
													>
														<span class="collection__filter-menu-title-text" style="pointer-events: none;">${facet.name.toString().toUpperCase()}</span>
														<i class="collection__filter-menu-title-icon collection__filter-menu-title-icon--plus" style="pointer-events: none;">
															<svg version="1.1" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="11px" height="11px" viewBox="0 0 11 11" xml:space="preserve">
																<polygon fill="#231f20" points="4.982,0 2.709,0 5.993,5.313 2.709,11 4.982,11 8.291,5.313">
															</svg>
														</i>
														<i class="collection__filter-menu-title-icon collection__filter-menu-title-icon--minus" style="pointer-events: none;">
															<svg version="1.1" aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="11px" height="11px" viewBox="0 0 11 11" xml:space="preserve">
																<polygon fill="#231f20" points="11,4.982 11,2.709 5.687,5.993 0,2.709 0,4.982 5.687,8.291 "/>
															</svg>
														</i>
													</button>
													${filterOptions}
													<div class="collection__filter-actions">
														<button type="button" class="collection__filter-view" data-collections-filter-view aria-label="View (${this.totalProducts})">VIEW (${this.totalProducts})</button>
														<button type="button" class="collection__filter-clear" data-collections-filter-clear>Clear All</button>
													</div>
												</div>
											</div>
										`

										const newMenu = this.createElementFromHTML(filterMenuMarkup)
										filterMenuContainer.appendChild(newMenu)
									}
								})
							} else {
								this.buildFilterClearButtons()
							}
						}

						// CLS
						document.querySelector('.filters--mobile').style.display = null
					}

					priceFilterChange() {
						const sliders = document.querySelectorAll('[data-facet-slider-control]');
						sliders.forEach(el => {
							const fromSlider = el.querySelector('[data-from-slider]');
							const toSlider = el.querySelector('[data-to-slider]');

							if (!fromSlider || !toSlider) return;
							const sliderChange = () => {
								this.updateStateQueryParams();
								this.updateVisibleProducts();
								this.buildFilterClearButtons();
							};

							fromSlider.addEventListener('change', sliderChange);
							toSlider.addEventListener('change', sliderChange);
						});
					}

					createSearchPageHeader() {
						if (window.isNostoSearchPage) {
							const urlParams = new URLSearchParams(window.location.search)
							const query = urlParams.get('q')

							const searchPageHeader = document.createElement('h1')
							searchPageHeader.innerText = `Search Results For "${query? query : ''}"`
							searchPageHeader.classList.add('collection__search-page-header')

							const collectionTitleContainer = document.querySelector('[data-collection-title-wrapper]')
							if (collectionTitleContainer) {
								collectionTitleContainer.appendChild(searchPageHeader)
							}
						}
					}

					initializeQuickAddButtons() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-product-tile-size]')) {
								const item = e.target
								const container = item.closest('[data-product-tile]')
								const id = item.getAttribute('data-product-tile-variant-id')
								const available = item.getAttribute('data-product-tile-variant-available')
								const message = container.querySelector('[data-product-tile-size-message]')
								const messageText = message.textContent

								const data = {
									id: id,
									quantity: 1
								}

								if (available !== false) {
									message.textContent = 'Added to Bag!'
									item.classList.add('active')
									container.classList.add('quickadd-mobile')

									setTimeout(() => {
										window.addToBag(data)
									}, 100)

									setTimeout(() => {
										container.classList.remove('quickadd-mobile')
										message.textContent = messageText
									}, 1600)
								}
							}
						})
					}

					initFilters() {
						let requestBody = null
						if (!window.isNostoSearchPage) {
							requestBody = this.getPLPFacetRequestBody()
						} else {
							requestBody = this.getSearchPageFacetRequestBody()
						}

						fetch(this.nostoGQLEndpoint, {
							method: 'POST',
							headers: this.nostoGQLHeaders,
							body: JSON.stringify(requestBody)
						})
						.then((response) => response.json())
						.then((res) => {
							const facets = res.data.search.products.facets.map(obj => {
								if (obj.field == 'brand') {
									const brands = obj.data.filter((e) => e.value != 'Lemonade');
									if (brands.length) obj.data = brands
									else obj.data = []
								}
								return obj
							})
							try {
								facets.sort((a, b) => {
									const aIndex = this.facetSortRanking.includes(a.name.toLowerCase())? this.facetSortRanking.indexOf(a.name.toLowerCase()): '500'
									const bIndex = this.facetSortRanking.includes(b.name.toLowerCase())? this.facetSortRanking.indexOf(b.name.toLowerCase()): '500'

									return aIndex - bIndex
								})
								const colourIndex = facets.findIndex(facet => facet.name.includes('Colour'))
								if (colourIndex >= 0) {
									const arraymove = (arr, fromIndex, toIndex) => {
										const element = arr[fromIndex]
										arr.splice(fromIndex, 1)
										return arr.splice(toIndex, 0, element)
									}
									facets = arraymove(facets,colourIndex,1)
								}
							} catch(e) {
								console.error(e)
							}
							this.buildFilters(facets)
							this.priceFilterChange()
							this.selectFiltersFromQueryParams()
							this.buildFilterClearButtons()
						})
						.catch((e) => {
							console.error(e)
						})
					}

					selectFiltersFromQueryParams() {
						const restoredFilters = []
						const restoredRangeFilters = []
						const url = new URL(window.location.href)
						const searchParams = new URLSearchParams(url.search)

						for (const param of searchParams) {
							const key = param[0]
							if (key.startsWith('filter.')) {
								const newKey = key.split('filter.')[1]
								const newValue = param[1].split(',')
								restoredFilters.push({field: newKey, value: newValue})
							}

							if (key.startsWith('filterRange.')) {
								const splitKey = key.split('.')
								if (splitKey.length === 3) {
									const rangeType = splitKey[1]
									const rangeTitle = splitKey[2]
									const value = param[1]
									restoredRangeFilters.push({field: rangeTitle, type: rangeType, value: value})
								}
							}
						}

						restoredFilters.forEach(filter => {
							filter.value.forEach(filterValue => {
								const checkbox = document.querySelector(`[data-collection-facet-checkbox][data-facet-name="${filter.field}"][data-facet-value="${filterValue}"]`)
								checkbox.classList.add('checked')
								checkbox.setAttribute('aria-checked', 'true')
							})
						})

						restoredRangeFilters.forEach(filter => {
							const sliderContainer = document.querySelector(`[data-facet-slider-control][data-facet-name=${filter.field}]`)
							const parentContainer = sliderContainer.parentElement

							if (sliderContainer) {
								if (filter.type === 'gte') {
									const fromSlider = sliderContainer.querySelector('[data-from-slider]')
									const fromDisplay = parentContainer.querySelector('[data-from-display]')
									if (fromSlider && fromDisplay) {
										fromSlider.value = filter.value
										fromDisplay.innerHTML = filter.value
									}
								} else {
									const toSlider = sliderContainer.querySelector('[data-to-slider]')
									const toDisplay = parentContainer.querySelector('[data-to-display]')
									if (toSlider && toDisplay) {
										toSlider.value = filter.value
										toDisplay.innerHTML = filter.value
									}
								}
							}
						})
					}

					getBadge(collectionIds, inventory, tags) {
						let productStockStatus = 'out-of-stock'
						let productStockBadgeClass = ' hidden'
						let productStockBadgeText = ''


						const veganEditUSId = '179654164564'
						const veganEditAUId = '211837550664'
						// Product Tile Badges badges
						let cleanTags = tags.map(tag => tag.toLowerCase())

						if (inventory > 0 && !cleanTags.includes('limited stock')) {
							productStockStatus = 'in-stock'
						}

						if (cleanTags.includes('limited offer')) {
							productStockBadgeText = 'Flash Sale!'
							productStockBadgeClass = ' product-tile__stock-badge--flash-sale'
						} else if (cleanTags.includes('selling fast')) {
							productStockBadgeText = 'Selling Fast'
							productStockBadgeClass = ' product-tile__stock-badge--selling-fast'
						} else if (cleanTags.includes('limited stock')) {
							productStockBadgeText = 'Limited Stock'
							productStockBadgeClass = ' product-tile__stock-badge--limited-stock'
						} else if (cleanTags.includes('princess polly petite')) {
							productStockBadgeText = 'Petite'
							productStockBadgeClass = ' product-tile__stock-badge--petite'
						} else if (cleanTags.includes('princess polly curve')) {
							productStockBadgeText = 'Curve'
							productStockBadgeClass = ' product-tile__stock-badge--curve'
						} else if (cleanTags.includes('princess polly tall')) {
							productStockBadgeText = 'Tall'
							productStockBadgeClass = ' product-tile__stock-badge--tall'
						} else if (collectionIds.includes(veganEditUSId) || collectionIds.includes(veganEditAUId)) {
							productStockBadgeText = 'Vegan'
							productStockBadgeClass = ' product-tile__stock-badge--vegan'
						}

						const badgeArr = tags.filter((tag) => tag.includes('Badge:') || tag.includes('badge:'))

						if (badgeArr.length) {
							const badgeText = badgeArr[0].split(':').pop()
							productStockBadgeText = badgeText
							productStockBadgeClass = ` product-tile__stock-badge--${this.handleize(badgeText)}`
						}

						let productStockBadge = `
							<p class="product-tile__stock-badge${productStockBadgeClass}" data-product-tile-stock>
								<span>${productStockBadgeText}</span>
							</p>
						`.trim()

						const badgeData = {
							productStockBadge: productStockBadge,
							productStockStatus: productStockStatus,
							cleanTags: cleanTags
						}

						return badgeData
					}

					buildProductTiles(products) {
						const template = `
							<div
								class="product-tile"
								data-product-tile="{{itemHandle}}"
								data-id="{{itemId}}"
								{{metaProductsDataAttr}}
							>
								<div class="product-tile__media" data-product-tile-media data-product-url>
									<div class="product-tile__carousel" data-product-tile-carousel>{{itemImages}}</div>
									{{itemQuickAdd}}
									{{productStockBadge}}
								</div>
								<div data-product-wishlist-modal class="product-wishlist-modal-wrap"></div>
								{{itemQuickAddLink}}
								<div class="product-tile__info">
									<a href="{{itemUrl}}" class="product-tile__name" data-product-title data-product-url>{{itemTitle}}</a>
									<div class="product-tile__wishlist--info">{{wishlistMarkup}}</div>
									<div class="product-tile__meta{{itemSaleClass}}" data-product-meta>
										<p class="product-tile__brand" data-product-vendor{{itemVendorClass}}>{{itemVendor}}</p>
										<span aria-label="Was {{itemPrice}}" class="product-tile__price" data-product-price data-currency-conversion="{{itemPrice}}">{{itemPrice}}</span>{{itemSalePrice}}
										{{itemPricesVary}}
										<span class="product-tile__price product-tile__sale-price {{salePriceClass}}" data-product-sale-price>
											<span class="product-tile__price-savings" data-product-savi="tile">{{salePrice}}</span>
										</span>
										<div class="product-promotion-container" data-product-promotion-container>
											<product-promotion
												data-product-promotion-moment="${window.moment}"
												style="display: flex;"
											>
												<em class="product-promotion"
													data-product-promotion-message
													data-price="{{rawPrice}}"
													data-collection-ids="{{itemCollectionIds}}"
													data-tags="{{cleanTags}}"
												></em>
											</product-promotion>
										</div>
									</div>
									<div class="swatches">
										<div class="product-tile__swatches" data-product-tile-swatches="tile">
											{{swatchesForTile}}
										</div>
									</div>
								</div>
							</div>
						`

						const tileContainer = document.querySelector('[data-nosto-collection]')
						if (tileContainer) {
							tileContainer.innerHTML = ''
							// Create no results page if no products
							if (products.length === 0) {
								if (window.hasOwnProperty('shopifyCollection') && window.shopifyCollection.hasOwnProperty('noResults')) {
									const noResults = window.shopifyCollection.noResults
									if (noResults) {
										tileContainer.innerHTML = `<div class="nosto_element" id="${noResults}"></div>`
										if (window.nostojs) {
											window.nostojs((api) => {
												api.loadRecommendations()
											})
										}
									}
								}
								return
							}
							products.forEach(product => {
								let itemHtml = template
								itemHtml = itemHtml.replace(/{{itemUrl}}/g, product.url)
								itemHtml = itemHtml.replace(/{{itemTitle}}/g, product.name)
								itemHtml = itemHtml.replace(/{{itemVendor}}/g, product.brand)
								itemHtml = itemHtml.replace(/{{itemId}}/g, product.productId)

								const itemVendorClass = product.brand === 'blank' || product.brand === 'Princess Polly' || product.brand === 'Lemonade' || product.brand.length === 0? ' hidden' : ''
								itemHtml = itemHtml.replace(/{{itemVendorClass}}/g, itemVendorClass)

								let productPrice = ''
								let listPrice = ''
								if (window.Shopify.currency.active === window.theme.baseCurrency) {
									productPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(product.price)
									listPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'}).format(product.listPrice)
								}
								itemHtml = itemHtml.replace(/{{itemPrice}}/g, productPrice)
								itemHtml = itemHtml.replace(/{{rawPrice}}/g, product.price * 100)

								let salePriceMarkup = ''
								let itemSaleClass = ''
								let salePriceClass = 'hidden'
								let salePrice = ''
								if (product.listPrice !== product.price) {
									salePriceMarkup = `<s aria-label="Was ${listPrice}" class="product-tile__price-sale" data-product-price-sale>${listPrice}</s>`
									itemSaleClass = ' product-tile__meta--sale'
									salePriceClass = ''
									if (listPrice.length > 0) {
										salePrice = Math.round(100 - ((parseFloat(product.price) / parseFloat(product.listPrice)).toFixed(4)) * 100) + '% off'
									}
								}

								itemHtml = itemHtml.replace(/{{itemSalePrice}}/g, salePriceMarkup)
								itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass)
								itemHtml = itemHtml.replace(/{{salePriceClass}}/g, salePriceClass)
								itemHtml = itemHtml.replace(/{{salePrice}}/g, salePrice)

								let priceVariesMarkup = ''
								itemHtml = itemHtml.replace(/{{itemPricesVary}}/g, priceVariesMarkup)

								const productHandle = product.url.split('/products/')[1].split('/')[0].split('?')[0]
								itemHtml = itemHtml.replace(/{{itemHandle}}/g, productHandle)


								let wishlistMarkup = ''
								wishlistMarkup = this.buildWishlist(product)
								itemHtml = itemHtml.replace(/{{wishlistMarkup}}/g, wishlistMarkup)

								let itemImages = ''

								const collectionHandles = this.getProductMetafield(product, 'accentuate', 'collection_handle')
								const collectionImages = this.getProductMetafield(product, 'accentuate', 'collection_image')
								if (collectionHandles.length && collectionImages.length) {
									const handles = JSON.parse(collectionHandles)
									const images = JSON.parse(collectionImages)
									if (handles.length == images.length && window.shopifyCollection) {
										images.forEach((image, i) => {
											if (window.shopifyCollection.handle) {
												if (handles[i] == window.shopifyCollection.handle) {
													const imageUrl = image[0].cloudinary_src
													itemImages += `
														<div class="swiper-slide">
															<a href="${product.url}" class="product-tile__image-link" aria-label="${product.name}">
																<figure class="product-tile__image-holder">
																	<img
																		src="${imageUrl + 'w_373,h_506'}"
																		srcset="
																			${imageUrl + 'w_639,h_866'} 1800w,
																			${imageUrl + 'w_598,h_811'} 1600w,
																			${imageUrl + 'w_532,h_721'} 1350w,
																			${imageUrl + 'w_448,h_607'} 1280w,
																			${imageUrl + 'w_425,h_576'} 1024w,
																			${imageUrl + 'w_510,h_691'} 768w,
																			${imageUrl + 'w_382,h_518'} 576w,
																			${imageUrl + 'w_573,h_777'} 414w,
																			${imageUrl + 'w_412,h_558'} 375w
																		"
																		class="product-tile__image"
																		height="610"
																		width="450"
																		alt="${product.name}"
																		data-override-handle="${handles[i]}"
																		loading="lazy"
																	/>
																</figure>
															</a>
														</div>
													`
												}
											}
										})
									}
								}

								itemImages += `
									<div class="swiper-slide">
										<a href="${product.url}" class="product-tile__image-link" aria-label="${product.name}">
											<figure class="product-tile__image-holder">
												<img
													src="${this.imgURL(product.imageUrl, '373x506', true)}"
													srcset="
														${this.imgURL(product.imageUrl, '639x866', true)} 1800w,
														${this.imgURL(product.imageUrl, '598x811', true)} 1600w,
														${this.imgURL(product.imageUrl, '532x721', true)} 1350w,
														${this.imgURL(product.imageUrl, '448x607', true)} 1280w,
														${this.imgURL(product.imageUrl, '425x576', true)} 1024w,
														${this.imgURL(product.imageUrl, '510x691', true)} 768w,
														${this.imgURL(product.imageUrl, '382x518', true)} 576w,
														${this.imgURL(product.imageUrl, '573x777', true)} 414w,
														${this.imgURL(product.imageUrl, '412x558', true)} 375w
													"
													class="product-tile__image"
													height="610"
													width="450"
													alt="${product.name}"
													loading="lazy"
												/>
											</figure>
										</a>
									</div>
								`
								if (product.alternateImageUrls) {
									product.alternateImageUrls.forEach(imageURL => {
										itemImages += `
											<div class="swiper-slide">
												<a href="${product.url}" class="product-tile__image-link" aria-label="${product.name}">
													<figure class="product-tile__image-holder">
														<img
															src="${this.imgURL(imageURL, '373x506', true)}"
															srcset="
																${this.imgURL(imageURL, '639x866', true)} 1800w,
																${this.imgURL(imageURL, '598x811', true)} 1600w,
																${this.imgURL(imageURL, '532x721', true)} 1350w,
																${this.imgURL(imageURL, '448x607', true)} 1280w,
																${this.imgURL(imageURL, '425x576', true)} 1024w,
																${this.imgURL(imageURL, '510x691', true)} 768w,
																${this.imgURL(imageURL, '382x518', true)} 576w,
																${this.imgURL(imageURL, '573x777', true)} 414w,
																${this.imgURL(imageURL, '412x558', true)} 375w
															"
															class="product-tile__image"
															height="610"
															width="450"
															alt="${product.name}"
															loading="lazy"
														/>
													</figure>
												</a>
											</div>
										`
									})
								}

								itemHtml = itemHtml.replace(/{{itemImages}}/g, `
									<div class="swiper-wrapper">
										${itemImages}
									</div>
									<div class="swiper-button-prev"></div>
									<div class="swiper-button-next"></div>
								`)

								// Badge Logic
								let concattedProductTags = product.tags1
								if (product.tags2) {
									concattedProductTags = concattedProductTags.concat(product.tags2)
								}
								if (product.tags3) {
									concattedProductTags = concattedProductTags.concat(product.tags3)
								}

								// console.log({test: product.categoryIds})
								const badgeData = this.getBadge(product.categoryIds, product.inventoryLevel, concattedProductTags, product.brand)

								itemHtml = itemHtml.replace(/{{productStockBadge}}/g, badgeData.productStockBadge)
								itemHtml = itemHtml.replace(/{{productStockStatus}}/g, badgeData.productStockStatus)

								// Product Promotions
								itemHtml = itemHtml.replace(/{{itemCollectionIds}}/g, product.categoryIds.join(','))
								itemHtml = itemHtml.replace(/{{cleanTags}}/g, badgeData.cleanTags)

								let metaProductsDataAttr = ''
								const swatchTag = concattedProductTags.find((tag) => tag.startsWith('swatches-'))
								if (swatchTag) {
									metaProductsDataAttr += 'data-swatch-products=\'' + swatchTag + '\''
								}
								itemHtml = itemHtml.replace(/{{metaProductsDataAttr}}/g, metaProductsDataAttr)

								// TODO: Swatches - Need Nosto API key for this
								// Create the markup for size (select options) and color (swatches)
								let colorMarkupForTile = ''
								let uniqueColors = []
								let productInventory = 0
								let quickaddSizeTemplate = ''
								let variantAvailable = []
								let variantSizes = []

								for (let skuIt = 0; skuIt < product.skus?.length; skuIt++) {
									const variant = product.skus[skuIt]
									const customFieldsColor = variant.customFields.find(field => field.key.toLowerCase().trim() === 'color')
									let color = customFieldsColor? customFieldsColor.value :  variant.name.split(' / ')[1]

									productInventory += variant.inventory_quantity

									// Quick Add
									const variantOptionSize = variant.name.split(' / ')[0]
									if (variantOptionSize && !variantSizes.includes(variantOptionSize)) {
										let name = variantOptionSize
										let disabled = variant.availability === 'InStock' ? '' : ' disabled'

										if (variant.availability !== 'InStock' && 'hiddenOOSSizes' in window && Array.isArray(window.hiddenOOSSizes) && window.hiddenOOSSizes.indexOf(name.toLowerCase()) >= 0) {
											continue
										}

										name = this.trimSizeName(name)

										variantAvailable.push(variant.availability === 'InStock')
										variantSizes.push(variantOptionSize)
										quickaddSizeTemplate += `
											<li class="product-tile-size__item${disabled}">
												<button
													class="product-tile-size__button"
													type="button"
													data-product-tile-size
													data-product-tile-variant-id="${variant.id}"
													data-product-tile-variant-available="${variant.availability === 'InStock'}"
												>${name}</button>
											</li>
										`
									}

									// Set up swatches
									if (uniqueColors.indexOf(color) === -1) {
										if (!color) {
											continue
										}

										// Only add unique colors
										uniqueColors.push(color)
										const slug = color.toLowerCase().replace(' ', '-')
										const handleizedSlug = this.handleize(slug)
										const filename = window.nostoFileURL.replace('/?', `/color-${handleizedSlug}.png?`)
										const primaryImageArray = [product.imageUrl]
										const secondaryImageArray = product.alternateImageUrls? [...product.alternateImageUrls] : []
										const imagesArray = primaryImageArray.concat(secondaryImageArray)
										// Only use background image when no swatch hex provided
										const swatchColor = this.getProductMetafield(product, 'accentuate', 'swatch_color')
										let swatchStyle = `background-color: ${swatchColor};`
										if (swatchColor == '') {
											swatchStyle = `background-image: url('${filename}');`
										}

										colorMarkupForTile += `
											<a
												data-swatch
												title="${color}"
												data-color="${this.handleize(color).charAt(0).toUpperCase() + this.handleize(color).slice(1)}"
												class="swatch ${skuIt === 0 ? 'swatch--active' : ''}"
												href="${product.url}?variant=${variant.id}"
												style="${swatchStyle}"
											></a>
										`
									}
								}

								itemHtml = itemHtml.replace(/{{swatchesForTile}}/g, colorMarkupForTile)

								let itemQuickAddLink = `
									<button type="button" class="product-tile__quick" data-product-tile-quickadd data-product-url>
										<span class="product-tile__quick-text" style="pointer-events: none;">Quick Add</span>
										<span class="product-tile__quick-sold-out" style="pointer-events: none;">Sold Out</span>
									</button>
								`
								itemHtml = itemHtml.replace(/{{itemQuickAddLink}}/g, itemQuickAddLink)

								let itemQuickAddMessage = variantSizes.length <= 1 ? 'Add to my bag' : 'Select a Size'
								let itemQuickAdd = `
									<div class="product-tile-size" data-product-tile-quickadd-container>
										<p class="product-tile-size__title">
											<span data-product-tile-size-message>${itemQuickAddMessage}</span>
										</p>
										<ul class="product-tile-size__list" data-product-tile-quickadd-list>${quickaddSizeTemplate}</ul>
									</div>
								`
								itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, itemQuickAdd)

								const newTile = this.createElementFromHTML(itemHtml)
								tileContainer.appendChild(newTile)
							})
						}
					}

					preloadImage(url) {
						const image = new Image()
						image.src = url
					}

					imgURL(src, size, center = false) {
						if (src === undefined || src === 'undefined') return
						// Remove any current image size then add the new image size
						let centerVal = ''

						if (center) {
							centerVal = '_crop_center'
						}
						if (src === null) {
							return
						}

						return src
							.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
							.replace(/\.jpg|\.png|\.gif|\.jpeg/g, match => {
								return '_' + size + centerVal + match
							})
							.replace('https://cdn.shopify.com/s/files/1/0061/8627/0804/', 'https://us.princesspolly.com/cdn/shop/')
							.replace('https://cdn.shopify.com/s/files/1/0076/6040/4818/', 'https://www.princesspolly.com.au/cdn/shop/')
					}

					quickAddEvents() {
						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-product-tile-quickadd]')) {
								const targets = document.querySelectorAll('.product-tile')
								const container = e.target.closest('[data-product-tile]')

								targets.forEach((target) => {
									if (container != target) target.classList.remove('quickadd')
								});
								container.classList.toggle('quickadd')
							} else {
								const target = document.querySelector('.product-tile.quickadd')
								if (target) target.classList.remove('quickadd')
							}
						})
					}

					swatchEvents() {
						const imageWidth = 450
						const imageHeight = 610

						document.addEventListener('click', (e) => {
							if (e.target.matches('[data-swatch]')) {
								e.preventDefault()
								const swatch = e.target
								const productHandle = swatch.getAttribute('href').split('/products/')[1].split('?')[0]
								const swatchParent = swatch.parentElement

								if (swatchParent.querySelectorAll('[data-swatch]').length == 1) return
								if (swatch.classList.contains('swatch--active')) return

								if (swatchParent.querySelector('.swatch--active')) {
									swatchParent.querySelector('.swatch--active').classList.remove('swatch--active')
								}
								swatch.classList.add('swatch--active')

								fetch(`/products/${productHandle}?view=meta.json`)
									.then((res) => res.json())
									.then((response) => {
										const container = swatch.closest('[data-product-tile]')
										const carouselContainer = container.querySelector('[data-product-tile-carousel]')
										const mediaContainer = container.querySelector('[data-product-tile-media]')
										const priceContainer = container.querySelector('[data-product-price]')
										const stockContainer = container.querySelector('[data-product-tile-stock]')
										const saleDiscount = container.querySelector('[data-product-sale-price]')
										const saleDiscountClass = container.querySelector('[data-product-sale-price]')
										const sizeContainer = container.querySelector('[data-product-tile-quickadd-container]')
										const sizeList = container.querySelector('[data-product-tile-quickadd-list]')
										const titleContainer = container.querySelector('[data-product-title]')
										const wishlistContainer = container.querySelector('[data-swym-wishlist-button]').parentElement
										const saleDisplay = container.querySelector('[data-product-price-sale]')
										const promotionMessage = container.querySelector('[data-product-promotion-message]')
										const meta = container.querySelector('[data-product-meta]')

										container.setAttribute('data-product-tile', productHandle)
										container.dispatchEvent(new CustomEvent('datachange'))

										// Title
										titleContainer.textContent = response.title
										// Price
										let productPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify.currency.active, currencyDisplay: 'narrowSymbol' }).format(response.product.price / 100)
										if (this.commaDecimalCurrencies.includes(window.Shopify.currency.active)) {
											productPrice = productPrice.replace('.', ',')
										}
										priceContainer.textContent = productPrice
										priceContainer.setAttribute('data-currency-conversion', productPrice)
										if (saleDisplay) {
											saleDisplay.remove()
										}
										if (response.product.compare_at_price_min !== 0) {
											let formattedSalePrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify.currency.active, currencyDisplay: 'narrowSymbol' }).format(response.product.compare_at_price / 100)
											if (this.commaDecimalCurrencies.includes(window.Shopify.currency.active)) {
												formattedSalePrice = formattedSalePrice.replace('.', ',')
											}
											const salePrice = document.createElement('s')
											salePrice.setAttribute('aria-label', `Was ${formattedSalePrice}`)
											salePrice.setAttribute('data-product-price-sale', '')
											salePrice.setAttribute('data-currency-conversion', formattedSalePrice)
											salePrice.classList.add('product-tile__price-sale')
											salePrice.textContent = formattedSalePrice
											priceContainer.after(salePrice)
											saleDiscount.textContent = Math.round(100 - ((parseFloat(response.product.price) / parseFloat(response.product.compare_at_price)).toFixed(4)) * 100) + '% off'
											if (saleDiscountClass.classList.contains('hidden')) {
												saleDiscountClass.classList.remove('hidden')
											}
											meta.classList.add('product-tile__meta--sale')
										} else {
											saleDiscount.innerHTML = ''
											saleDiscountClass.classList.add('hidden')
											if (meta.classList.contains('product-tile__meta--sale')) {
												meta.classList.remove('product-tile__meta--sale')
											}
										}
										// Images
										var itemImages = ''
										if (response.override_handle && response.override_image && response.override_handle.length == response.override_image.length) {
											response.override_image.forEach((image, i) => {
												if (window.shopifyCollection) {
													if (window.shopifyCollection.handle) {
														if (response.override_handle[i] == window.shopifyCollection.handle) {
															const imageUrl = image.cloudinary_src
															itemImages += `
																<div class="swiper-slide">
																	<a href="${response.url}" class="product-tile__image-link" aria-label="${response.title}">
																		<figure class="product-tile__image-holder">
																			<img
																				src="${imageUrl + 'w_373,h_506'}"
																				srcset="
																					${imageUrl + 'w_639,h_866'} 1800w,
																					${imageUrl + 'w_598,h_811'} 1600w,
																					${imageUrl + 'w_532,h_721'} 1350w,
																					${imageUrl + 'w_448,h_607'} 1280w,
																					${imageUrl + 'w_425,h_576'} 1024w,
																					${imageUrl + 'w_510,h_691'} 768w,
																					${imageUrl + 'w_382,h_518'} 576w,
																					${imageUrl + 'w_573,h_777'} 414w,
																					${imageUrl + 'w_412,h_558'} 375w
																				"
																				class="product-tile__image"
																				height="610"
																				width="450"
																				alt="${response.title}"
																				data-override-handle="${response.override_handle[i]}"
																				loading="lazy"
																			/>
																		</figure>
																	</a>
																</div>
															`
														}
													}
												}
											})
										}
										response.product.images.forEach((imageUrl, i) => {
											itemImages += `
												<div class="swiper-slide">
													<a href="${response.url}" class="product-tile__image-link" aria-label="${response.title}">
														<figure class="product-tile__image-holder">
															<img
																src="${this.imgURL(imageUrl, '373x506', true)}"
																srcset="
																	${this.imgURL(imageUrl, '639x866', true)} 1800w,
																	${this.imgURL(imageUrl, '598x811', true)} 1600w,
																	${this.imgURL(imageUrl, '532x721', true)} 1350w,
																	${this.imgURL(imageUrl, '448x607', true)} 1280w,
																	${this.imgURL(imageUrl, '425x576', true)} 1024w,
																	${this.imgURL(imageUrl, '510x691', true)} 768w,
																	${this.imgURL(imageUrl, '382x518', true)} 576w,
																	${this.imgURL(imageUrl, '573x777', true)} 414w,
																	${this.imgURL(imageUrl, '412x558', true)} 375w
																"
																class="product-tile__image"
																alt="${response.title}"
																height="610"
																width="450"
																loading="lazy"
															/>
														</figure>
													</a>
												</div>
											`
										})
										// destroy existing carousel and initialize a fresh one
										carouselContainer.swiper.destroy()
										carouselContainer.innerHTML = `
											<div class="swiper-wrapper">
												${itemImages}
											</div>
											<div class="swiper-button-prev"></div>
											<div class="swiper-button-next"></div>
										`

										let swiperOptions = {
											navigation: {
												nextEl: '.swiper-button-next',
												prevEl: '.swiper-button-prev',
											},
											loop: true, // Hopefully swiper fixes this working with lazy.checkInView
											preloadImages: false,
											lazy: {
												checkInView: true,
												loadPrevNext: true,
												loadPrevNextAmount: 1,
												elementClass: 'product-tile__image'
											},
											on: {
												afterInit: (swiper) => {
													window.addEventListener('load', () => {
														setTimeout(() => {
															swiper.update()
														}, 500)
													})
												}
											}
										}
										new Swiper(carouselContainer, swiperOptions)

										// Inventory Badge
										let productStockStatus = 'out-of-stock'
										let productStockBadgeClass = 'hidden'
										let productStockBadgeText = ''
										var inventory = 0
										response.inventory.map((item) => { inventory += item.quantity })

										const veganEditUSId = '179654164564'
										const veganEditAUId = '211837550664'
										// Product Tile Badges badges
										let cleanTags = response.product.tags.map(tag => tag.toLowerCase())

										if (inventory > 0 && !cleanTags.includes('limited stock')) {
											productStockStatus = 'in-stock'
										}

										if (cleanTags.includes('limited offer')) {
											productStockBadgeText = 'Flash Sale!'
											productStockBadgeClass = 'product-tile__stock-badge--flash-sale'
										} else if (cleanTags.includes('selling fast')) {
											productStockBadgeText = 'Selling Fast'
											productStockBadgeClass = 'product-tile__stock-badge--selling-fast'
										} else if (cleanTags.includes('limited stock')) {
											productStockBadgeText = 'Limited Stock'
											productStockBadgeClass = 'product-tile__stock-badge--limited-stock'
										} else if (cleanTags.includes('princess polly petite')) {
											productStockBadgeText = 'Petite'
											productStockBadgeClass = 'product-tile__stock-badge--petite'
										} else if (cleanTags.includes('princess polly curve')) {
											productStockBadgeText = 'Curve'
											productStockBadgeClass = 'product-tile__stock-badge--curve'
										} else if (cleanTags.includes('princess polly tall')) {
											productStockBadgeText = 'Tall'
											productStockBadgeClass = 'product-tile__stock-badge--tall'
										} else if (response.product_collection_ids.includes(veganEditUSId) || response.product_collection_ids.includes(veganEditAUId)) {
											productStockBadgeText = 'Vegan'
											productStockBadgeClass = 'product-tile__stock-badge--vegan'
										}

										const badgeArr = response.product.tags.filter((tag) => tag.includes('Badge:') || tag.includes('badge:'))

										if (badgeArr.length) {
											const badgeText = badgeArr[0].split(':').pop()
											productStockBadgeText = badgeText
											productStockBadgeClass = ` product-tile__stock-badge--${this.handleize(badgeText)}`
										}

										container.setAttribute('data-product-stock', inventory)
										stockContainer.removeAttribute('class')
										stockContainer.classList.add('product-tile__stock-badge')
										stockContainer.classList.add(productStockBadgeClass)
										stockContainer.textContent = productStockBadgeText

										// Sizes
										let variantAvailable = []
										let variantSizes = []
										let quickaddSizeTemplate = this.buildQuickSizes(response.product, variantSizes, variantAvailable)

										if (response.additional_sizes && response.additional_sizes.handle !== response.product.handle && response.additional_sizes.available){
											let optionsIndex = null
											response.additional_sizes.options.forEach((option, i) => {
												if (option === 'Size') optionsIndex = i + 1
											})
											let additionalSizesTemplate = this.buildQuickSizes(response.additional_sizes, variantSizes, variantAvailable)
											const append = parseInt(this.trimSizeName(response.additional_sizes.variants[0]['option' + optionsIndex])) < parseInt(this.trimSizeName(variantSizes[0])) ? false : true

											const sizeBreak = '<li class="product-tile-size__break"><li>'
											if (append) {
												additionalSizesTemplate = sizeBreak + additionalSizesTemplate
												quickaddSizeTemplate += additionalSizesTemplate
											} else {
												additionalSizesTemplate = additionalSizesTemplate + sizeBreak
												quickaddSizeTemplate = additionalSizesTemplate + quickaddSizeTemplate
											}
										}

										sizeList.innerHTML = quickaddSizeTemplate

										if (variantSizes.every((val, i, arr) => val === arr[0]) && variantSizes.length > 1) {
											sizeContainer.classList.add('hidden')
										} else {
											if (sizeContainer.classList.contains('hidden')) {
												sizeContainer.classList.remove('hidden')
											}
										}
										if (variantAvailable[0] === false && variantAvailable.every((val, i, arr) => val === arr[0])) {
											container.classList.add('hidden-size-mobile')
										} else {
											if (container.classList.contains('hidden-size-mobile')) {
												container.classList.remove('hidden-size-mobile')
											}
										}
										// Promotion Message
										const collectionIds = []
										response.product_collections.forEach((collection) => {
											collectionIds.push(collection.id)
										})
										promotionMessage.setAttribute('data-price', response.product.price)
										promotionMessage.setAttribute('data-collection-ids', collectionIds.toString())
										promotionMessage.removeAttribute('data-promotion-populated')
										promotionMessage.dispatchEvent(new CustomEvent('datachange'))
										this.updateProductPromotions()
										// wishlist
										wishlistContainer.innerHTML = this.buildWishlist(response.product)
										if (this.wishProducts.some(wp => wp.empi === response.product.id)) {
											container.classList.add('wish-exists')
										} else {
											container.classList.remove('wish-exists')
										}
									})
									.catch((e) => {
										console.error(e)
									})
							}
						})
					}

					createQuickAddRenderListener() {
						const tiles = document.querySelectorAll('.collection-items [data-product-tile]')
						tiles.forEach((tile) => {
							let observer = new IntersectionObserver((entries, observer) => {
							entries.forEach(entry => {
								if (entry.isIntersecting || entry.intersectionRatio > 0) {
									this.buildFilledQuickSizesAndIntlPricing(tile)
									observer.unobserve(entry.target)
								}
								})
							})
							observer.observe(tile)
						})
					}

					buildFilledQuickSizesAndIntlPricing(tile) {
						const productHandle = tile.dataset.productTile

						const quickAddList = tile.querySelector('[data-product-tile-quickadd-list]')
						if (!quickAddList) return;

						fetch(`${window.Shopify.routes.root}products/${productHandle}?view=meta.json`)
						.then((response) => response.json())
						.then((response) => {
							try {
								if (window.Shopify.currency.active !== window.theme.baseCurrency) {
									let intlPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify.currency.active, currencyDisplay: 'narrowSymbol' }).format(response.product.price / 100)
									if (this.commaDecimalCurrencies.includes(window.Shopify.currency.active)) {
										intlPrice = intlPrice.replace('.', ',')
									}
									const priceEl = tile.querySelector('[data-product-price]')
									if (priceEl) {
										priceEl.innerHTML = intlPrice
									}
									if (response.product.compare_at_price_min !== 0) {
										let intlCompareAt = new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify.currency.active, currencyDisplay: 'narrowSymbol' }).format(response.product.compare_at_price / 100)
										if (this.commaDecimalCurrencies.includes(window.Shopify.currency.active)) {
											intlCompareAt = intlCompareAt.replace('.', ',')
										}
										const salePriceEl = tile.querySelector('[data-product-price-sale]')
										if (salePriceEl) {
											salePriceEl.innerHTML = intlCompareAt
										}
										const salePercentEl = tile.querySelector('[data-product-sale-price]')
										if (salePercentEl) {
											salePercentEl.innerHTML = Math.round(100 - ((parseFloat(response.product.price) / parseFloat(response.product.compare_at_price)).toFixed(4)) * 100) + '% off'
										}
									}
								}
							}
							catch(e) {
								console.log(e)
							}

							const productHandle = tile.dataset.productTile
							const quickAddList = tile.querySelector('[data-product-tile-quickadd-list]')

							if (!quickAddList) return;

							const additionalSizes = quickAddList.querySelectorAll('[data-product-tile-additional-size]')
								additionalSizes.forEach((el) => {
								el.remove()
							})

							const mainProduct = response.product
							let items = ''
							let variantSizes = []
							let variantAvailable = []
							let optionsIndex = null
							mainProduct.options.forEach((option, i) => {
								if (option == 'Size') {
								optionsIndex = i + 1
								}
							})

							mainProduct.variants.forEach((v) => {
								if (v[`option${optionsIndex}`] && !variantSizes.includes(v[`option${optionsIndex}`])) {
									let name = v[`option${optionsIndex}`]
									let disabled = v.available ? '' : ' disabled'
									const notValid = !v.available && 'hiddenOOSSizes' in window && Array.isArray(window.hiddenOOSSizes) && window.hiddenOOSSizes.indexOf(name.toLowerCase()) >= 0

									if(!notValid) {
										name = this.trimSizeName(name)
										variantAvailable.push(v.available)

										variantSizes.push(v[`option${optionsIndex}`])


										items += `
											<li class="product-tile-size__item${disabled}" data-product-tile-additional-size>
												<button
													class="product-tile-size__button"
													type="button"
													data-product-tile-size
													data-product-tile-variant-id="${v.id}"
													data-product-tile-variant-available="${v.available}"
												>${name}</button>
											</li>
										`.trim()
									}
								}
							})

							const additionalSizeProduct = response.additional_sizes
							if (additionalSizeProduct && additionalSizeProduct.handle !== productHandle && additionalSizeProduct.available) {
								let optionsIndex = null
								additionalSizeProduct.options.forEach((option, i) => {
									if (option == 'Size') {
										optionsIndex = i + 1
									}
								})

								let additionalItems = ''
								let additionalVariantSizes = []
								let additionalVariantAvailable = []
								additionalSizeProduct.variants.forEach((v) => {
									if (v[`option${optionsIndex}`] && !additionalVariantSizes.includes(v[`option${optionsIndex}`])) {
										let name = v[`option${optionsIndex}`]
										let disabled = v.available ? '' : ' disabled'
										const notValid = !v.available && 'hiddenOOSSizes' in window && Array.isArray(window.hiddenOOSSizes) && window.hiddenOOSSizes.indexOf(name.toLowerCase()) >= 0

										if(!notValid) {
											name = this.trimSizeName(name)
											additionalVariantAvailable.push(v.available)

											additionalVariantSizes.push(v[`option${optionsIndex}`])


											additionalItems += `
											<li class="product-tile-size__item${disabled}" data-product-tile-additional-size>
												<button
													class="product-tile-size__button"
													type="button"
													data-product-tile-size
													data-product-tile-variant-id="${v.id}"
													data-product-tile-variant-available="${v.available}"
												>${name}</button>
											</li>
											`.trim()
										}
									}
								})

								if (additionalVariantSizes.length > 0) {
									const firstMainVariantSize = parseInt(this.trimSizeName(variantSizes[0]))
									const firstAdditionalVariantSize = parseInt(this.trimSizeName(additionalVariantSizes[0]))
									if (!isNaN(firstMainVariantSize) && !isNaN(firstAdditionalVariantSize)) {
										const sizeBreak = '<li class="product-tile-size__break" data-product-tile-additional-size><li>'
										items = firstMainVariantSize > firstAdditionalVariantSize? additionalItems + sizeBreak + items : items + sizeBreak + additionalItems
									}
								}
							}

							quickAddList.innerHTML = items
						})
					}

					handleize (str) {
						str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
						.replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
						.replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
						.replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
						.toLowerCase() // To lowercase

						return str
					}

					getProductMetafield(product, namespace, metafieldName) {
						const metafield = product.customFields.find(field => {
							return field.key === namespace + '-' + metafieldName
						})
						if (metafield) {
							return metafield.value
						}
						return ''
					}

					trimSizeName(name) {
						name = name.replace('AU', '')
						name = name.replace('US', '')
						name = name.replace('iPhone', '')
						name = name.replace('SHOE', '')
						name = name.replace('One Size', 'ONE SIZE')
						name = name.replace('ONE SIZE', 'ONE SIZE')
						return name.trim()
					}

					buildQuickSizes(product, variantSizes=[], variantAvailable=[]) {
						let quickaddSizeTemplate = ''
						var optionsIndex = null
						product.options.forEach((option, i) => {
							if (option === 'Size') optionsIndex = i + 1
						})
						if (optionsIndex === null) return
						product.variants.forEach((variant) => {
							if (!variantSizes.includes(variant['option' + optionsIndex])) {
								var name = variant['option' + optionsIndex]
								var available = variant.available
								var disabled = available ? '' : ' disabled'
								name = this.trimSizeName(name)
								variantAvailable.push(variant.available)
								variantSizes.push(variant['option' + optionsIndex])
								quickaddSizeTemplate += `
									<li class="product-tile-size__item${disabled}">
										<button
											class="product-tile-size__button"
											type="button"
											data-product-tile-size
											data-product-tile-variant-id="${variant.id}"
											data-product-tile-variant-available="${available}"
										>${name}</button>
									</li>
								`
							}
						})

						return quickaddSizeTemplate
					}

					ajaxCollectionData(collectionHandle) {
						fetch(`/collections/${collectionHandle}?view=meta.json`)
							.then((response) => response.json())
							.then((res) => {
								const elements = document.querySelectorAll(`[data-swatch-products="${collectionHandle}"] [data-product-tile-swatches]`)
								elements.forEach((element) => {
									let swatchMarkup = ''
									res.products.forEach((p) => {
										var optionsIndex = null
										p.product.options.forEach((option, i) => {
											if (option === 'Color') optionsIndex = i + 1
										})

										if (optionsIndex === null) return

										// Hide fully out of stock swatches
										if (!p.product.available) return
										const firstColor = p.product.variants[0][`option${optionsIndex}`]
										const handleizedFirstColor = this.handleize(firstColor)
										const filename = window.nostoFileURL.replace('/?', `/color-${handleizedFirstColor}.png?`)
										const swatchTitle = firstColor
										const theColor = p.color !== null ? p.color : firstColor

										if (element.querySelector(`[title="${swatchTitle}"]`)) {
											return
										}

										// Only use background image when no swatch hex provided
										let swatchStyle = `background-color: ${p.color};`
										if (p.color === null) {
											swatchStyle = `background-image: url('${filename}');`
										}

										const containerHandle = element.closest('.product-tile').getAttribute('data-product-tile')
										const swatchClass = p.handle === containerHandle ? ' swatch--active' : ''

										let markupForTile = `
											<a
												href="${p.url}"
												data-swatch
												title="${swatchTitle}"
												data-color="${theColor}"
												class="swatch${swatchClass}"
												style="${swatchStyle}"
											></a>
										`

										swatchMarkup += markupForTile
									})
									element.innerHTML = element.innerHTML + swatchMarkup
								})
							})
							.catch((e) => {
								console.error(e)
							})
					}

					initializeSwipers() {
						let swiperOptions = {
							a11y: {
								enabled: true,
								slideRole: "group"
							},
							lazy: {
								checkInView: true,
								loadPrevNext: true,
								loadPrevNextAmount: 1,
								elementClass: 'product-tile__image'
							},
							loop: true,
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
							on: {
								afterInit: (swiper) => {
									window.addEventListener('load', () => {
										setTimeout(() => {
											swiper.update()
										}, 500)
									})
								}
							}, // Hopefully swiper fixes this working with lazy.checkInView
							preloadImages: false,
							resizeObserver: true,
							roundLengths: false,
							updateOnWindowResize: true,
							watchSlidesProgress: true
						}

						// Carousels
						const swiper = new Swiper('[data-product-tile-carousel]', swiperOptions)
						window.collectionSwipers = swiper
					}

					createElementFromHTML(htmlString) {
						let div = document.createElement('div')
						div.innerHTML = htmlString.trim()

						// Change this to div.childNodes to support multiple top-level nodes.
						return div.firstChild
					}

					paginationTemplate() {
						return `
							<nav class="paginate" aria-label="pagination">
								<div class="paginate__viewed">You've Viewed <strong>{{viewingLast}}</strong> of <strong>{{totalProduct}}</strong> Styles</div>
								<div class="paginate__progress">
									<div
										class="paginate__progress-bar"
										role="progressbar"
										aria-label="Pages"
										aria-valuetext="Page {{currentPage}}"
										aria-valuenow="{{currentPage}}"
										aria-valuemin="1"
										aria-valuemax="{{totalPages}}"
										style="width: {{progress}};"
									></div>
								</div>
								<ol class="paginate__list">{{previous}}{{pageItems}}{{next}}</ol>
							</nav>
						`
					}

					previousActiveHtmlTemplate() {
						return `
							<li class="paginate__item">
								<button data-prev-page-button class="paginate__link paginate__link--prev" aria-label="Page Previous">
									<svg version="1.1" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve" style="pointer-events: none;">
										<circle fill="#ffffff" cx="25" cy="25" r="25"/>
										<polygon fill="#231f20" points="27.628,15.126 22.086,24.087 21.764,24.617 22.069,25.157 27.689,34.891 25.583,34.891 19.633,24.652 25.566,15.126" />
									</svg>
								</button>
							</li>
						`
					}

					previousDisabledHtmlTemplate() {
						return `
							<li class="paginate__item">
								<span class="paginate__link paginate__link--prev paginate__link--disabled" aria-label="Page Previous">
									<svg version="1.1" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve" style="pointer-events: none;">
										<circle fill="#ffffff" cx="25" cy="25" r="25"/>
										<polygon fill="#231f20" points="27.628,15.126 22.086,24.087 21.764,24.617 22.069,25.157 27.689,34.891 25.583,34.891 19.633,24.652 25.566,15.126" />
									</svg>
								</span>
							</li>
						`
					}

					nextActiveHtmlTemplate() {
						return `
							<li class="paginate__item">
								<button data-next-page-button class="paginate__link paginate__link--next" aria-label="Page Next">
									<svg version="1.1" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve" style="pointer-events: none;">
										<circle fill="#ffffff" cx="25" cy="25" r="25"/>
										<polygon fill="#231f20" points="22.373,15.126 27.914,24.087 28.236,24.617 27.932,25.157 22.312,34.891 24.417,34.891 30.368,24.652 24.435,15.126" />
									</svg>
								</button>
							</li>
						`
					}

					nextDisabledHtmlTemplate() {
						return `
							<li class="paginate__item">
								<span class="paginate__link paginate__link--next paginate__link--disabled" aria-label="Page Next">
									<svg version="1.1" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" xml:space="preserve" style="pointer-events: none;">
										<circle fill="#ffffff" cx="25" cy="25" r="25"/>
										<polygon fill="#231f20" points="22.373,15.126 27.914,24.087 28.236,24.617 27.932,25.157 22.312,34.891 24.417,34.891 30.368,24.652 24.435,15.126" />
									</svg>
								</span>
							</li>
						`
					}

					pageItemRemainHtmlTemplate() {
						return `
							<li class="paginate__item">
								<span class="paginate__link paginate__link--remain" aria-label="Page ...">{{itemTitle}}</span>
							</li>
						`
					}

					pageItemSelectedHtmlTemplate() {
						return `
							<li class="paginate__item">
								<span class="paginate__link paginate__link--active" aria-label="Page {{itemTitle}}, Current Page" aria-current="true">{{itemTitle}}</span>
							</li>
						`
					}

					pageItemHtmlTemplate() {
						return `
							<li class="paginate__item">
								<button data-jump-page-button data-page-num={{itemTitle}} class="paginate__link" aria-label="Page {{itemTitle}}">{{itemTitle}}</button>
							</li>
						`
					}

					buildToolbarLink(pageNumber) {
						if (!isNaN(pageNumber)) {
							let searchParams = new URLSearchParams(window.location.search)
							searchParams.set("page", pageNumber)
							let newUrl = window.location.pathname + '?' + searchParams.toString()
							return newUrl
						}

						const baseUrl = window.location.href.split('?')[0]
						return baseUrl
					}

					buildTopPagination(currentPage, totalPages) {
						let topPaginationMarkup = ''
						if (totalPages > 1) {
							let prevPageLink = ''
							if (currentPage > 1) {
								prevPageLink = `
									<div class="pagination__item">
										<button data-prev-page-button aria-label="Page Previous">
											<svg xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true" width="6" height="11" version="1.1" viewBox="0 0 6 11" style="pointer-events: none;">
												<path d="M5.689,10.943l-3.125-5.443L5.689.057h-2.23L.311,5.5l3.149,5.443h2.23Z"/>
											</svg>
										</button>
									</div>
								`
							}

							let nextPageLink = ''
							if (currentPage < totalPages) {
								nextPageLink = `
									<div class="pagination__item">
										<button data-next-page-button aria-label="Page Next">
											<svg xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true" width="6" height="11" version="1.1" viewBox="0 0 6 11" style="pointer-events: none;">
												<path d="M.311.057l3.125,5.443L.311,10.943h2.23l3.149-5.443L2.54.057H.311Z"/>
											</svg>
										</button>
									</div>
								`
							}

							topPaginationMarkup = `
								${prevPageLink}
								<div class="pagination__info">
									<p class="pagination__page">Page ${currentPage} of ${totalPages}</p>
								</div>
								${nextPageLink}
							`
						} else {
							topPaginationMarkup = ''
						}

						const paginations = document.querySelectorAll('[data-top-pagination]')
						paginations.forEach((pagination) => {
							pagination.innerHTML = topPaginationMarkup
						})
					}

					buildBottomPagination(currentPage, totalPages, numProductsPerPage, totalProducts) {
						var viewingLast = numProductsPerPage

						if (totalProducts < numProductsPerPage) {
							viewingLast = totalProducts
						}

						// If it has only one page, clear Pagination
						let paginationHtml = ''
							if (totalPages > 1) {
							if (currentPage > 1) {
								viewingLast = currentPage * numProductsPerPage
							}

							if (currentPage === totalPages) {
								viewingLast = totalProducts
							}

							var percentage = (100 * parseFloat(viewingLast)) / parseFloat(totalProducts)
							var progress = percentage < 100 ? `${percentage}%` : '100%'

							paginationHtml = this.paginationTemplate()

							var previousLink = currentPage - 1 === 1? window.location.href.split('?')[0] : this.buildToolbarLink(currentPage - 1)
							// Build Previous
							var previousHtml = (currentPage > 1) ? this.previousActiveHtmlTemplate() : this.previousDisabledHtmlTemplate()
							previousHtml = previousHtml.replace(/{{itemUrl}}/g, previousLink)
							paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)

							// Build Next
							var nextHtml = (currentPage < totalPages) ? this.nextActiveHtmlTemplate() : this.nextDisabledHtmlTemplate()
							nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink(currentPage + 1))
							paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)

							// Create page items array
							var beforeCurrentPageArr = []
							for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
								beforeCurrentPageArr.unshift(iBefore)
							}
							if (currentPage - 4 > 0) {
								beforeCurrentPageArr.unshift('...')
							}
							if (currentPage - 4 >= 0) {
								beforeCurrentPageArr.unshift(1)
							}
							beforeCurrentPageArr.push(currentPage)

							var afterCurrentPageArr = []
							for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPages; iAfter++) {
								afterCurrentPageArr.push(iAfter)
							}
							if (currentPage + 3 < totalPages) {
								afterCurrentPageArr.push('...')
							}
							if (currentPage + 3 <= totalPages) {
								afterCurrentPageArr.push(totalPages)
							}

							// Build page items
							var pageItemsHtml = ''
							var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
							for (var iPage = 0; iPage < pageArr.length; iPage++) {
								if (pageArr[iPage] == '...') {
									pageItemsHtml += this.pageItemRemainHtmlTemplate()
								} else {
									pageItemsHtml += (pageArr[iPage] == currentPage) ? this.pageItemSelectedHtmlTemplate() : this.pageItemHtmlTemplate()
								}
								pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
								pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink(pageArr[iPage]))
							}
							paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)
							paginationHtml = paginationHtml.replace(/{{viewingLast}}/g, viewingLast)
							paginationHtml = paginationHtml.replace(/{{totalProduct}}/g, totalProducts)
							paginationHtml = paginationHtml.replace(/{{progress}}/g, progress)
							paginationHtml = paginationHtml.replace(/{{currentPage}}/g, currentPage)
							paginationHtml = paginationHtml.replace(/{{totalPages}}/g, totalPages)
						}

						document.querySelector(this.selector.bottomPagination).innerHTML = paginationHtml
					}

					buildPagination(totalProducts) {
						const currentPage = this.getCurrentPage()

						const numProductsPerPage = this.pageSize
						var totalPages = Math.ceil(totalProducts / numProductsPerPage)
						if (typeof window.maxPages !== 'undefined') {
							totalPages = Math.min(totalPages, window.maxPages)
						}
						const maxProducts = totalPages * numProductsPerPage
						if (totalProducts > maxProducts) {
							totalProducts = maxProducts
						}

						this.buildTopPagination(currentPage, totalPages)
						this.buildBottomPagination(currentPage, totalPages, numProductsPerPage, totalProducts)
						const title = document.querySelector('[data-collection-title]')
						if (title) title.textContent = `${totalProducts} Styles`
					}

					buildViewButtons(totalProducts) {
						const buttons = document.querySelectorAll('[data-collections-filter-view]')
						buttons.forEach((button) => {
							button.setAttribute('aria-label', `View (${totalProducts})`)
							button.innerHTML = `VIEW (${totalProducts})`
						})
					}
				}
			)
		}
	} else if (window.disableNosto) {
		const initializeQuickAddButtons = () => {
			document.addEventListener('click', (e) => {
				if (e.target.matches('[data-product-tile-size]')) {
					const item = e.target
					const container = item.closest('[data-product-tile]')
					const id = item.getAttribute('data-product-tile-variant-id')
					const available = item.getAttribute('data-product-tile-variant-available')
					const message = container.querySelector('[data-product-tile-size-message]')
					const messageText = message.textContent

					const data = {
						id: id,
						quantity: 1
					}

					if (available !== false) {
						message.textContent = 'Added to Bag!'
						item.classList.add('active')
						container.classList.add('quickadd-mobile')

						setTimeout(() => {
							window.addToBag(data)
						}, 100)

						setTimeout(() => {
							container.classList.remove('quickadd-mobile')
							message.textContent = messageText
						}, 1600)
					}
				}
			})
		}

		const quickAddEvents = () => {
			document.addEventListener('click', (e) => {
				if (e.target.matches('[data-product-tile-quickadd]')) {
					const container = e.target.closest('[data-product-tile]')
					container.classList.toggle('quickadd')
				} else {
					const target = document.querySelector('.product-tile.quickadd')
					if (target) target.classList.remove('quickadd')
				}
			})
		}

		let wishProducts = []
		fetchCollectionWishlists()

		document.addEventListener('collection:wishlist', (event) => {
			if (document.querySelector('[data-nosto-collection]')) {
				const productTiles = document.querySelectorAll('[data-nosto-collection] [data-product-tile]')

				wishProducts = event.detail

				Array.from(productTiles).forEach(tile => {
					initializeWishlists(tile)
				})
			}
		})

		const initializeWishlists = (tile) => {
			let observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting || entry.intersectionRatio > 0) {
						renderWishlists(tile)
						observer.unobserve(entry.target)
					}
				})
			})
			observer.observe(tile)
		};

		const renderWishlists = (tile) => {
			const p = tile
			const pId = p.hasAttribute('data-id') ? parseInt(p.getAttribute('data-id')) : null
			if (pId) {
				if (wishProducts.some(wp => wp.empi === pId)) {
					p.classList.add('wish-exists')
				} else {
					p.classList.remove('wish-exists')
				}
			}
		};

		quickAddEvents()
		initializeQuickAddButtons()
	}

	const fetchCollectionWishlists = () => {
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = [];
		}
		window.SwymCallbacks.push(() => {
			window._swat.fetchLists({
				callbackFn: response => {
					if (response.length) {
						let listIds = [];
						let lists = [];
						let data = [];
						response.forEach((item, i) => {
							if (listIds.includes(item.lid)) return;
							lists.push(item);
							listIds.push(item.lid);
						});
						lists.forEach((item, i) => {
							const productsArray = [];
							window._swat.fetchListCtx(
								{
									lid: item.lid
								},
								products => {
									if (products.length) {
										const uniqueProducts = products.filter((e, i) => products.findIndex(a => a.epi === e.epi) === i);

										uniqueProducts.forEach(product => {
											window._swat.getProductDetails(
												product,
												resp => {
													resp.swym = product;

													resp.variants.forEach(variant => {
														if (variant.id === resp.swym.epi) {
															resp.selected_variant = variant;
														}
													});
													productsArray.push(resp);
												},
												err => {
													console.log(err);
												}
											);
										});
									}
								},
								err => {
									console.log(err);
								}
							);
							data.push(productsArray);
						});

						const wishProducts = lists.map(list => list.listcontents).flat();

						document.dispatchEvent(new CustomEvent('collection:wishlist', {
							detail: wishProducts
						}));
					}
				},
				errorFn: err => {
					console.log(err);
				}
			});
		});
	}
})();
